import {
    Box, HStack, Input, Button, Table, Thead, Tbody, Tr, Th, Td, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Image, Heading,
    Alert,
    AlertIcon,
    AlertTitle,
    List,
    ListItem,
    ListIcon,
    OrderedList,
    UnorderedList,
    Textarea,
    Stack,
    VStack,
    Select,
    Link,
    Progress,
    Checkbox,
    Tooltip, Spinner,
    Divider, PopoverCloseButton, PopoverBody, useDisclosure, Icon, keyframes,
    useToast, IconButton, Grid, GridItem, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel,
    TableContainer, Tfoot, useMediaQuery, Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow,
    FormControl, FormLabel,
    Spacer, Collapse, Switch, Badge
} from '@chakra-ui/react';
import ReactDOMServer from 'react-dom/server';
import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import ProdutoImagem from "../components/ProdutoImagem";
import { FiMoreVertical, FiPlus, FiMinus } from 'react-icons/fi';
import { GoPackage } from "react-icons/go";
import { MdLocalShipping, MdCancel, MdNoteAdd, MdLocalOffer } from "react-icons/md";
import { IoMdSend, IoMdCart, IoMdChatboxes, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaCopy, FaEllipsisV, FaEye, FaBox, FaSearch, FaCartArrowDown, FaMap, FaFileAlt, FaCommentDots, FaClipboardCheck, FaCheckSquare, FaTrash, FaCheckCircle, FaBackspace, FaFilter, FaDownload, FaFileInvoice, FaInfoCircle } from 'react-icons/fa';
import {
    getVendasML, setVendaCotacao, getVenda, setFuroEstoqueVenda, setStatusTaga, criarObsVenda, apagarObsVenda,
    atualizarVendas, setMarcadorVenda, imprimirEtiquetaML, emitirNfML, consultarRetornoProcessamento,
    setStatusVenda, getVendaManual, createTicket, emitirNfeTaga, downloadNfeArquivo, getCotacoesStatusVendas,
    getMensageriaStatusLeitura,
} from "../services/api";
import ChatMensagensML from "../components/ChatMensagensML";
import Preloader from "../components/Preloader";
import PreloaderMini from "../components/PreloaderMini";
import Notas from "../components/Notas";
import MultipleSelect from "../components/MultipleSelect";
import MultipleSelectMktplacesVendas from "../components/MultipleSelectMktplacesVendas";
import MultipleSelectFornecedoresVendas from "../components/MultipleSelectFornecedoresVendas";
import MarcadoresVenda from "../components/MarcadoresVenda";
import ModalNfeVendas from "../components/ModalNfeVendas";
import ScrollToTop from "../components/ScrollToTop";
import { formatDistanceToNow, parse, parseISO, isToday, isBefore } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import $ from 'jquery';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { MdCheck, MdEdit, MdStar } from 'react-icons/md';
import { FaBookmark, FaBoxOpen, FaCarCrash, FaExternalLinkAlt } from "react-icons/fa";
import { MdDoNotDisturb, MdMoneyOff, MdErrorOutline, MdImageNotSupported } from "react-icons/md";
import { checkPermission, checkPermissionUser } from "../services/permission";
import { AiFillDollarCircle } from "react-icons/ai";
import FiltrosVendas from "../components/FiltrosVendas";
import StatusVendasMktplaces from "../components/StatusVendasMktplaces";
import StatusVendasTaga from "../components/StatusVendasTaga";
import { DateTime } from "luxon";
import StatusConferenciaBadge from "../components/StatusConferenciaBadge";
import VendaItem from "../components/VendaItem";
import VendaCardV2 from "../components/VendaCardV2";
import VendasKanban, { AlternarVisao } from "../components/VendasKanban";
import { produtosAtivos } from "../components/OcorrenciasItemVenda";
import { ROTULO_SECAO, SOMBRA } from "../components/VendaCardV2/ui";


import '../index.css';

// Quantos grupos de venda o celular renderiza por vez. Cada card custa ~250 nos de DOM;
// a lista inteira passava de 55 mil e o Safari matava a aba.
const LOTE_CELULAR = 25;

const Vendas = () => {
    const [isMobile] = useMediaQuery("(max-width: 768px)");
    const [loading, setLoading] = useState(false);
    const [loadingLinear, setLoadingLinear] = useState(false);
    const [loadingMini, setLoadingMini] = useState(false);
    const [loadingMini2, setLoadingMini2] = useState(false);
    const toast = useToast()

    const [openPedidosFooter, setOpenPedidosFooter] = useState({});
    const toggleAccordionPedidosFooter = useCallback((id) => {
        setOpenPedidosFooter((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    }, []);

    const [isOpenStatusTaga, setIsOpenStatusTaga] = useState(true);
    const toggleDropdownStatusTaga = () => { setIsOpenStatusTaga(!isOpenStatusTaga); };
    const [isOpenStatusMkt, setIsOpenStatusMkt] = useState(true);
    const toggleDropdownStatusMkt = () => { setIsOpenStatusMkt(!isOpenStatusMkt); };

    // Aberta via link (ex.: /vendas?busca=ID vindo da Mensageria): habilita todos
    // os status para garantir que a venda apareca independente do status dela.
    const [selectedOptionsStatus, setSelectedOptionsStatus] = useState(
        new URLSearchParams(window.location.search).get("busca")
            ? [
                { label: "Confirmadas", value: "confirmada" },
                { label: "Para enviar", value: "enviar" },
                { label: "Em trânsito", value: "transito" },
                { label: "Concluídas", value: "concluida" },
                { label: "Canceladas", value: "cancelada" },
            ]
            : [
                { label: "Confirmadas", value: "confirmada" },
                { label: "Para enviar", value: "enviar" },
            ]
    );

    const [selectedOptionsMktplaces, setSelectedOptionsMktplaces] = useState([{ label: "Mercado Livre (1)", value: "0" },
    { label: "Mercado Livre (2)", value: "1" }, { label: "Mercado Livre (3)", value: "7" }, { label: "Mercado Shops", value: "2" }, { label: "Magalu", value: "3" }, { label: "Amazon", value: "4" },
    { label: "TAGA (Venda Manual)", value: "5" }, { label: "TAGA (Ecommerce)", value: "6" }
    ]);

    const [isOpen, setIsOpen] = useState(false);
    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
    const [selectedVendaForTicket, setSelectedVendaForTicket] = useState(null);
    const [ticketTemplate, setTicketTemplate] = useState('');
    const [isCreatingTicket, setIsCreatingTicket] = useState(false);

    const openTicketModal = useCallback((pedido) => {
        setSelectedVendaForTicket(pedido);
        setIsTicketModalOpen(true);
        setMenuVisivel(false); // Fecha o menu de ações
    }, []);

    const closeTicketModal = () => {
        setIsTicketModalOpen(false);
        setSelectedVendaForTicket(null);
        setTicketTemplate('');
        setIsCreatingTicket(false);
    };

    const handleConfirmCreateTicket = async () => {
        if (!ticketTemplate || !selectedVendaForTicket) {
            toast({
                title: "Erro",
                description: "Por favor, selecione um problema.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        setIsCreatingTicket(true);

        const userString = window.localStorage.getItem("user");
        if (!userString) {
            toast({
                title: "Erro de Autenticação",
                description: "Usuário não encontrado. Faça login novamente.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            setIsCreatingTicket(false);
            return;
        }
        const user = JSON.parse(userString);
        const currentUserId = user.id;

        const prioridadeString = 'baixa';

        const categoriaIdParaVendas = 2;

        const formData = new FormData();

        formData.append('subject', `Problema na Venda #${selectedVendaForTicket.id}`);
        formData.append('description', ticketTemplate);
        formData.append('priority', prioridadeString);
        formData.append('categoryIds[]', categoriaIdParaVendas);
        formData.append('assigneeIds[]', currentUserId);
        formData.append('linkedItems[]', selectedVendaForTicket.id);
        formData.append('linkedItems[]', selectedVendaForTicket.id_taga);

        try {
            const response = await createTicket(formData);

            toast({
                title: "Ticket Criado com Sucesso!",
                description: `O Ticket #${response.data.ticket_id} foi aberto. Redirecionando...`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });

            window.location.href = `https://admin.tagaautopartes.com.br/tickets/${response.data.ticket_id}`;

        } catch (error) {
            console.error("Erro ao criar ticket:", error.response?.data || error);
            toast({
                title: "Erro ao criar ticket",
                description: "Não foi possível criar o ticket. Verifique o console ou tente novamente.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
            setIsCreatingTicket(false);
        }
    };

    const handleSelectedOptionsMktplaces = (options) => {
        setSelectedOptionsMktplaces(options);
        let concatenatedString = "";
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                if (options[i] && options[i].value) {
                    concatenatedString += options[i].value;
                    if (i !== options.length - 1) {
                        concatenatedString += "-";
                    }
                }
            }
        }
        handleChangeFiltroMktplaces(concatenatedString);
    };

    const [selectedOptionsStatusFornecedor, setSelectedOptionsStatusFornecedor] = useState([{ label: "Morelate", value: "morelate" },
    { label: "Vannucci", value: "vannucci" }, { label: "Isapa", value: "isapa" }, { label: "BRCompany", value: "brcompany" }, { label: "Autolatina", value: "autolatina" }, { label: "LNG", value: "lng" }, { label: "CBA", value: "cba" }, { label: "MSAM", value: "msam" }, { label: "BL Parts", value: "blparts" }]);
    const [filtroFornecedor, setFiltroFornecedor] = useState("morelate-vannucci-isapa-brcompany-autolatina-lng-cba-msam-blparts");

    const handleSelectedOptionsFornecedoresChange = (options) => {
        setSelectedOptionsStatusFornecedor(options);
        let concatenatedString = "";
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                if (options[i] && options[i].value) {
                    concatenatedString += options[i].value;
                    if (i !== options.length - 1) {
                        concatenatedString += "-";
                    }
                }
            }
        }
        handleChangeFiltroFornecedores(concatenatedString);
    };
    const handleChangeFiltroFornecedores = (value) => {
        setFiltroFornecedor(value);
    };

    const handleSelectedOptionsStatusChange = (options) => {
        setSelectedOptionsStatus(options);
        let concatenatedString = "";
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                if (options[i] && options[i].value) {
                    concatenatedString += options[i].value;
                    if (i !== options.length - 1) {
                        concatenatedString += "-";
                    }
                }
            }
        }
        handleChangeFiltroStatus(concatenatedString);
    };

    const [isModalOpenAcaoIndiv, setIsModalOpenAcaoIndiv] = useState(false);

    const [isModalOpenCotacao, setIsModalOpenCotacao] = useState(false);
    const closeModalCotacao = () => setIsModalOpenCotacao(false);
    const openModalCotacao = () => setIsModalOpenCotacao(true);

    const [idPedidoMsg, setIdPedidoMsg] = useState("");
    const [pedidoMsgAtivo, setPedidoMsgAtivo] = useState(null);
    const [naoLidasPorPackId, setNaoLidasPorPackId] = useState({});
    const [isModalOpenStatusVenda, setIsModalOpenStatusVenda] = useState(false);
    const [idVendaSetStatus, setIdVendaSetStatus] = useState([]);
    const [valorStatusVenda, setValorStatusVenda] = useState("");
    const closeModalStatusVenda = () => setIsModalOpenStatusVenda(false);
    const handleClickSetStatusVenda = () => {
        closeModalStatusVenda();
        handleStatusVenda(idVendaSetStatus, valorStatusVenda);
    };

    const [isModalOpenMsg, setIsModalOpenMsg] = useState(false);
    const openModalMsg = () => { setIsModalOpenMsg(true); }
    const closeModalMsg = () => {
        setIsModalOpenMsg(false);
        setPedidoMsgAtivo(null);
        setIdPedidoMsg("");
    }

    const closeModalAcaoIndiv = () => setIsModalOpenAcaoIndiv(false);
    const [isModalOpenAcaoMassa, setIsModalOpenAcaoMassa] = useState(false);
    const openModalAcaoMassa = () => setIsModalOpenAcaoMassa(true);
    const closeModalAcaoMassa = () => setIsModalOpenAcaoMassa(false);

    const closeModalViewPedido = () => setIsModalOpenViewPedido(false);
    const [isModalOpenViewPedido, setIsModalOpenViewPedido] = useState(false);
    const openModalViewPedido = useCallback((idPedido) => {
        setLoadingLinear(true);
        setLoading(true);
        try {
            (async () => {
                const responseVenda = await getVenda(idPedido);
                if (responseVenda != false) {
                    setPedidoSelecionado(responseVenda);
                    setIsModalOpenViewPedido(true);
                } else {
                    toast({
                        title: `Não foi posssível consulta a venda.`,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        }
        catch {
            toast({
                title: `Não foi posssível consulta a venda.`,
                status: 'error',
                isClosable: true,
                duration: 1000,
            });
            setLoadingLinear(false);
            setLoading(false);
            return false;
        }
    }, [toast]);

    const closeModalViewPedidoTaga = () => setIsModalOpenViewPedidoTaga(false);
    const [isModalOpenViewPedidoTaga, setIsModalOpenViewPedidoTaga] = useState(false);
    const openModalViewPedidoTaga = useCallback((idPedido) => {
        setLoadingLinear(true);
        setLoading(true);
        try {
            (async () => {
                const responseVenda = await getVendaManual(idPedido);
                if (responseVenda != false) {
                    setPedidoManualSelecionado(responseVenda);
                    setIsModalOpenViewPedidoTaga(true);
                } else {
                    toast({
                        title: `Não foi posssível consulta a venda.`,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        }
        catch {
            toast({
                title: `Não foi posssível consulta a venda.`,
                status: 'error',
                isClosable: true,
                duration: 1000,
            });
            setLoadingLinear(false);
            setLoading(false);
            return false;
        }
    }, [toast]);


    const [selecaoMassa, setSelecaoMassa] = useState("selecione");
    var consultaVendas = false;
    const [pedidos, setPedidos] = useState([]);
    const pedidosRef = useRef([]);
    useEffect(() => { pedidosRef.current = pedidos; }, [pedidos]);

    const [cotacoesStatusByVenda, setCotacoesStatusByVenda] = useState({});
    useEffect(() => {
        if (!pedidos || pedidos.length === 0) {
            setCotacoesStatusByVenda({});
            return;
        }
        const ids = pedidos.map((p) => p.id).filter(Boolean);
        if (ids.length === 0) return;
        let cancelado = false;
        getCotacoesStatusVendas(ids).then((data) => {
            if (!cancelado) setCotacoesStatusByVenda(data || {});
        });
        return () => { cancelado = true; };
    }, [pedidos]);

    // Status de conferencia que liberam emissao de NFe / etiqueta
    // 1 = SUCESSO, 3 = EMBALADO, 4 = ENVIADO, 5 = LIBERADO_RESSALVA
    const STATUS_CONFERENCIA_OK = [1, 3, 4, 5];
    const isPedidoConferidoParaDespacho = (pedido) => {
        const ativos = produtosAtivos(pedido);
        if (ativos.length === 0) return false;
        return ativos.every(p => STATUS_CONFERENCIA_OK.includes(p.conferencia_status));
    };
    const findPedidoById = (idVenda) => pedidosRef.current.find(p => p.id_taga === idVenda || p.id === idVenda);
    const toastConferenciaPendente = (ref) => {
        toast({
            title: "Conferencia pendente",
            description: `A venda ${ref ?? ''} precisa estar totalmente conferida (status valido) antes de emitir NFe ou etiqueta.`,
            status: "warning",
            duration: 5000,
            isClosable: true,
        });
    };
    const [totalVendas, setTotalVendas] = useState([]);
    const [totalVendasTAGA, setTotalVendasTAGA] = useState([]);
    const [dataUltimaAtualizacaoVendas, setDataUltimaAtualizacaoVendas] = useState("");
    const [buscaBool, setBuscaBool] = useState(false);
    const [buscaAmpliada, setBuscaAmpliada] = useState(false);

    const [filtroBusca, setFiltroBusca] = useState(
        new URLSearchParams(window.location.search).get("busca") || "");
    const [filtroStatus, setFiltroStatus] = useState(
        new URLSearchParams(window.location.search).get("busca")
            ? "confirmada-enviar-transito-concluida-cancelada"
            : "confirmada-enviar");
    const [filtroMktplaces, setFiltroMktplaces] = useState("0-1-2-3-4-5-6-7");

    const [textObs, setTextObs] = useState("");

    var dataAtual = new Date();
    var ano = dataAtual.getFullYear();
    var mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    var dia = String(dataAtual.getDate()).padStart(2, '0');
    var dataFormatadaFinal = `${ano}-${mes}-${dia}`;

    // dataAtual = new Date();
    // dataAtual.setDate(dataAtual.getDate() - 14);
    // ano = dataAtual.getFullYear();
    // mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    // dia = String(dataAtual.getDate()).padStart(2, '0');
    // var dataFormatadaInicial = `${ano}-${mes}-${dia}`;
    dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 2);
    ano = dataAtual.getFullYear();
    mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    dia = String(dataAtual.getDate()).padStart(2, '0');
    var dataFormatadaInicial = `${ano}-${mes}-${dia}`;

    const [filtroDataInicial, setFiltroDataInicial] = useState(
        new URLSearchParams(window.location.search).get("busca")
            ? "2000-01-01"
            : dataFormatadaInicial);
    const [filtroDataFinal, setFiltroDataFinal] = useState(dataFormatadaFinal);

    const [pedidoManualSelecionado, setPedidoManualSelecionado] = useState("");
    const [pedidoSelecionado, setPedidoSelecionado] = useState("");
    const [textCotacaoMorelate, setTextCotacaoMorelate] = useState("");
    const [textCotacaoVannucci, setTextCotacaoVannucci] = useState("");
    const [textCotacaoIsapa, setTextCotacaoIsapa] = useState("");
    const [textCotacaoBrcompany, setTextCotacaoBrcompany] = useState("");
    const [textCotacaoLng, setTextCotacaoLng] = useState("");
    const [textCotacaoCba, setTextCotacaoCba] = useState("");
    const [textCotacaoMsam, setTextCotacaoMsam] = useState("");
    const [textCotacaoBlparts, setTextCotacaoBlparts] = useState("");
    const [stringCotacaoMorelate, setStringCotacaoMorelate] = useState("");
    const [stringCotacaoVannucci, setStringCotacaoVannucci] = useState("");
    const [stringCotacaoIsapa, setStringCotacaoIsapa] = useState("");
    const [stringCotacaoBrcompany, setStringCotacaoBrcompany] = useState("");
    const [stringCotacaoLng, setStringCotacaoLng] = useState("");
    const [stringCotacaoCba, setStringCotacaoCba] = useState("");
    const [stringCotacaoMsam, setStringCotacaoMsam] = useState("");
    const [stringCotacaoBlparts, setStringCotacaoBlparts] = useState("");


    const [checkboxesState, setCheckboxesState] = useState([]);
    const [masterCheckbox, setMasterCheckbox] = useState(false);
    const hoje = new Date().toISOString().split('T')[0];

    const [usarCardV2, setUsarCardV2] = useState(() => {
        try {
            return localStorage.getItem('taga_vendas_card_v2') === '1';
        } catch {
            return false;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('taga_vendas_card_v2', usarCardV2 ? '1' : '0');
        } catch {
        }
    }, [usarCardV2]);

    const [visaoKanban, setVisaoKanban] = useState(() => {
        try {
            return localStorage.getItem('taga_vendas_kanban') === '1';
        } catch {
            return false;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('taga_vendas_kanban', visaoKanban ? '1' : '0');
        } catch {
        }
    }, [visaoKanban]);

    const mostrarKanban = usarCardV2 && visaoKanban;
    const CardVenda = usarCardV2 ? VendaCardV2 : VendaItem;
    const larguraTopo = usarCardV2
        ? { w: "100%", ml: 0 }
        : { w: { base: "100%", md: "100%", lg: "100%", xl: "96%" }, ml: { base: "0", md: "0", lg: "12", xl: "10" } };

    const handleClearSelection = () => {
        setCheckboxesState([]);
        setMasterCheckbox(false);
    };

    // isPulsating removido - causava re-render da página inteira a cada 2s

    // const handleCheckboxChange = (pedidoId) => {
    //     const updatedCheckboxes = [...checkboxesState];
    //     const index = updatedCheckboxes.indexOf(pedidoId);
    //     if (index === -1) {
    //         // Se não estiver presente, adicione-o
    //         updatedCheckboxes.push(pedidoId);
    //     } else {
    //         // Se estiver presente, remova-o
    //         updatedCheckboxes.splice(index, 1);
    //     }
    //     setCheckboxesState(updatedCheckboxes);
    // };

    const handleCheckboxChange = useCallback((pedidoId) => {
        setCheckboxesState((prev) => {
            if (prev.includes(pedidoId)) {
                return prev.filter((id) => id !== pedidoId);
            } else {
                return [...prev, pedidoId];
            }
        });
    }, []);


    const handleMasterCheckboxChange = () => {
        // Se todos os pedidos estiverem marcados, desmarque todos
        var novoStatus = !masterCheckbox;
        setMasterCheckbox(novoStatus);
        if (novoStatus === false) {
            var pedidoIds = [];
        } else {
            var pedidoIds = pedidosFiltrados.map(pedido => pedido.id);
        }
        setCheckboxesState(pedidoIds);
    };


    function consultarVendas(carregar) {
        setLoadingLinear(true);
        if (carregar == true) {
            setLoading(true);
        }
        try {
            (async () => {
                var consulta = "busca=,status=" + filtroStatus + ",data_inicial=" + filtroDataInicial + ",data_final=" + filtroDataFinal + ",mktplaces=" + filtroMktplaces + ",fornecedores=" + filtroFornecedor;
                const responseVendas = await getVendasML(consulta, filtroBusca);
                if (responseVendas != false) {
                    setPedidos(responseVendas.vendas);
                    setTotalVendas(responseVendas.total)
                    setTotalVendasTAGA(responseVendas.total_taga)
                    setDataUltimaAtualizacaoVendas(responseVendas.data_ultima_atualizacao);
                    setBuscaBool(false);
                    setBuscaAmpliada(responseVendas.busca_ampliada === true);
                } else {
                    setPedidos([]);
                    setBuscaBool(true);
                    setBuscaAmpliada(false);
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        }
        catch {
            setLoadingLinear(false);
            setLoading(false);
            return false;
        }
    }

    function consultarMensagensVendas(id) {
        const pedidoEncontrado = pedidos.find(p => p.id === id);
        setPedidoMsgAtivo(pedidoEncontrado || null);
        setIdPedidoMsg(id);
        setIsModalOpenMsg(true);
    }

    function getImagemFornecedor(fornecedor) {
        var imagem = "/logo_vannucci.webp"
        if (fornecedor == "MORELATE") {
            imagem = "/logo_morelate.webp";
        } else if (fornecedor == "ISAPA") {
            imagem = "/logo_isapa.webp";
        } else if (fornecedor == "BRCOMPANY") {
            imagem = "/logo_brcompany.webp";
        } else if (fornecedor == "AUTOLATINA") {
            imagem = "/logo_autolatina.webp";
        } else if (fornecedor == "LNG") {
            imagem = "/logo_lng.webp";
        } else if (fornecedor == "CBA") {
            imagem = "/logo_cba.webp";
        } else if (fornecedor == "MSAM") {
            imagem = "/logo_msam.webp";
        } else if (fornecedor == "BLPARTS") {
            imagem = "/logo_blparts.webp";
        }
        return imagem;
    }

    const listaRef = useRef(null);
    const buttonRef = useRef(null);
    useEffect(() => {
        if (consultaVendas == false) {
            consultarVendas(true);
            consultaVendas = true;
        }

        const fecharMenuAoClicarFora = (event) => {
            // const elemento2 = document.getElementsByClassName("acoes_button");
            // if (listaRef.current && !listaRef.current.contains(event.target) && !(elemento2 == event.target || elemento2.contains(event.target))) {
            //     setMenuVisivel(false);
            // }

            const elementos = document.getElementsByClassName("acoes_button");
            if (listaRef.current && !listaRef.current.contains(event.target)) {
                let clicadoEmAcoesButton = false;

                for (let i = 0; i < elementos.length; i++) {
                    if (elementos[i] === event.target || elementos[i].contains(event.target)) {
                        clicadoEmAcoesButton = true;
                        break;
                    }
                }

                if (!clicadoEmAcoesButton) {
                    setMenuVisivel(false);
                }
            }

        };

        document.addEventListener('mousedown', fecharMenuAoClicarFora);

        return () => {
            document.removeEventListener('mousedown', fecharMenuAoClicarFora);
        };
    }, []);

    useEffect(() => {
        if (pedidos.length === 0) return;
        const packIds = pedidos.filter(p => p.pack_id).map(p => String(p.pack_id));
        if (packIds.length === 0) return;
        const userString = window.localStorage.getItem("user");
        if (!userString) return;
        const userId = JSON.parse(userString).id;
        const fetchStatus = async () => {
            try {
                const result = await getMensageriaStatusLeitura(packIds, userId);
                setNaoLidasPorPackId(result || {});
            } catch (_) {}
        };
        fetchStatus();
        const interval = setInterval(fetchStatus, 60000);
        return () => clearInterval(interval);
    }, [pedidos]);

    const handleChangeAcaoMassa = (event) => {
        setMenuVisivel(false);
        var idVendaIndiv = event.id_venda;
        if (checkboxesState.length === 0 && !idVendaIndiv) {
            toast({
                title: `Nenhum pedido selecionado`,
                status: 'error',
                isClosable: true,
                duration: 1000,
            });
            return;
        }

        const valorSelecionado = event.target.value;
        if (idVendaIndiv && idVendaIndiv.length !== 0) {
            if (valorSelecionado === "set_cotacao_sim") {
                handleCotacaoVenda([idVendaIndiv], 1);
            } else if (valorSelecionado === "set_cotacao_nao") {
                handleCotacaoVenda([idVendaIndiv], 0);
            } else if (valorSelecionado === "set_furo_estoque_sim") {
                handleFuroEstoqueVenda([idVendaIndiv], 1);
            } else if (valorSelecionado === "set_furo_estoque_nao") {
                handleFuroEstoqueVenda([idVendaIndiv], 0);
            } else if (valorSelecionado === "set_status_taga_retirar") {
                handleStatusTaga([idVendaIndiv], 0);
            } else if (valorSelecionado === "set_status_taga_sim") {
                handleStatusTaga([idVendaIndiv], 1);
            } else if (valorSelecionado === "set_status_taga_nao") {
                handleStatusTaga([idVendaIndiv], 2);
            } else if (valorSelecionado === "set_status_taga_pen") {
                handleStatusTaga([idVendaIndiv], 3);
            } else if (valorSelecionado === "lista_cotacao") {
                handleTextCotacao([idVendaIndiv]);
                openModalCotacao();
            } else if (valorSelecionado == "status_venda_1") {
                setIdVendaSetStatus(idVendaIndiv);
                setValorStatusVenda("CONFIRMADA");
                setIsModalOpenStatusVenda(true);
            } else if (valorSelecionado == "status_venda_2") {
                setIdVendaSetStatus(idVendaIndiv);
                setValorStatusVenda("PARA ENVIAR");
                setIsModalOpenStatusVenda(true);
            } else if (valorSelecionado == "status_venda_3") {
                setIdVendaSetStatus(idVendaIndiv);
                setValorStatusVenda("EM TRÂNSITO");
                setIsModalOpenStatusVenda(true);
            } else if (valorSelecionado == "status_venda_4") {
                setIdVendaSetStatus(idVendaIndiv);
                setValorStatusVenda("CONCLUÍDA");
                setIsModalOpenStatusVenda(true);
            } else if (valorSelecionado == "status_venda_5") {
                setIdVendaSetStatus(idVendaIndiv);
                setValorStatusVenda("CANCELADA");
                setIsModalOpenStatusVenda(true);
            }
        } else {
            if (valorSelecionado === "set_cotacao_sim") {
                handleCotacaoVenda(checkboxesState, 1);
            } else if (valorSelecionado === "set_cotacao_nao") {
                handleCotacaoVenda(checkboxesState, 0);
            } else if (valorSelecionado === "set_furo_estoque_sim") {
                handleFuroEstoqueVenda(checkboxesState, 1);
            } else if (valorSelecionado === "set_furo_estoque_nao") {
                handleFuroEstoqueVenda(checkboxesState, 0);
            } else if (valorSelecionado === "set_status_taga_retirar") {
                handleStatusTaga(checkboxesState, 0);
            } else if (valorSelecionado === "set_status_taga_sim") {
                handleStatusTaga(checkboxesState, 1);
            } else if (valorSelecionado === "set_status_taga_nao") {
                handleStatusTaga(checkboxesState, 2);
            } else if (valorSelecionado === "set_status_taga_pen") {
                handleStatusTaga(checkboxesState, 3);
            } else if (valorSelecionado === "lista_cotacao") {
                handleTextCotacao(checkboxesState);
                openModalCotacao();
            } else if (valorSelecionado === "imprimir_etiquetas_ml") {
                openModalImprimirEtiquetasMassaML(checkboxesState);
            } else if (valorSelecionado === "emitir_nfes_ml") {
                openModalEmitirNfesMassaML(checkboxesState);
            }
        }
        // openModalAcaoMassa(valorSelecionado);
        // setSelecaoMassa("selecione");
    };

    const handleChangeFiltroBusca = (event) => {
        setFiltroBusca(event.target.value);
    };

    const handleChangeFiltroMktplaces = (value) => {
        setFiltroMktplaces(value);
    };

    const handleChangeFiltroStatus = (value) => {
        setFiltroStatus(value);
    };

    const handleChangeFiltroDataInicial = (event) => {
        setFiltroDataInicial(event.target.value);
    };

    const handleChangeFiltroDataFinal = (event) => {
        setFiltroDataFinal(event.target.value);
    };

    const limparFiltros = () => {
        setFiltroBusca("");
        setFiltroStatus("");
        setFiltroDataInicial("");
        setFiltroDataFinal("");
        setSelectedOptionsStatus([]);
        setSelectedOptionsMktplaces([]);
        setSelectedOptionsStatusFornecedor([]);
    };

    const handlePesquisar = () => {
        consultarVendas(true);
    };

    function limitarCaracteres(str, limite) {
        if (str?.length && str.length > limite) {
            return str.slice(0, limite) + "...";
        }
        return str;
    }

    function quebrarCaractere(str) {
        var string = str.replace(/(.{20})/g, "$1\n");
        return string;
    }

    const getColorBasedOnBg = (color) => {
        if (color == "yellow.200") {
            return "black";
        } else {
            return "white";
        }
    };

    const getBgPedidoStatus = (pedido) => {
        var color = "#ffc499";

        // if (pedido.cotada == 1) {
        //     color = "#FF9F59";
        // }

        // if (pedido.furo_estoque == 1 || pedido.status_taga == 2) {
        //     color = "#e36864";
        // }

        if (pedido.marcador == 1) {
            color = "red.300";
        } else if (pedido.marcador == 2) {
            color = "yellow.300";
        } else if (pedido.marcador == 3) {
            color = "gray.400";
        } else if (pedido.marcador == 4) {
            color = "purple.300";
        } else if (pedido.marcador == 5) {
            color = "blue.400";
        } else if (pedido.marcador == 6) {
            color = "orange.300";
        }

        return color;
    };

    const getTextoMarcador = (pedido) => {

        //const markerTexts = ["Furo de Estoque", "Venda com Pendências", "Problema no Envio", "Erro de precificação", "Outros", "Produto Diferente", "Remover Marcador"];
        var text = "";
        if (pedido.marcador == 1) {
            var text = "FURO DE ESTOQUE";
        } else if (pedido.marcador == 2) {
            var text = "VENDA COM PENDÊNCIAS";
        } else if (pedido.marcador == 3) {
            var text = "PROBLEMA NO ENVIO";
        } else if (pedido.marcador == 4) {
            var text = "ERRO DE PRECIFICAÇÃO";
        } else if (pedido.marcador == 5) {
            var text = "OUTROS PROBLEMAS";
        } else if (pedido.marcador == 6) {
            var text = "PRODUTO DIFERENTE";
        }

        return text;
    };


    const getIconMarcador = (pedido) => {
        //const markerTexts = ["Furo de Estoque", "Venda com Pendências", "Problema no Envio", "Erro de precificação", "Outros", "Produto Diferente", "Remover Marcador"];
        var icon = "";
        if (pedido.marcador == 1) {
            var icon = <FaBoxOpen color="black" />;
        } else if (pedido.marcador == 2) {
            var icon = <MdDoNotDisturb color="black" />;
        } else if (pedido.marcador == 3) {
            var icon = <MdLocalShipping color="black" />;
        } else if (pedido.marcador == 4) {
            var icon = <MdMoneyOff color="black" />;
        } else if (pedido.marcador == 5) {
            var icon = <MdErrorOutline color="black" />;
        } else if (pedido.marcador == 6) {
            var icon = <MdImageNotSupported color="black" />;
        }
        return icon;
    };

    const getBgPedidoStatusTAGA = (pedido) => {
        if (pedido.status_taga == 1) { return "green.300"; }
        if (pedido.status_taga == 2) { return "red.300"; }
        if (pedido.status_taga == 3) { return "yellow.300"; }
        return "";
    };

    // const getBgPrazoEnvio = (data) => {
    //     const [day, month, year] = data.split('/').map(Number);

    //     const fullYear = year < 100 ? 2000 + year : year;

    //     const date = new Date(fullYear, month - 1, day);
    //     const today = new Date();  // Data de hoje

    //     date.setHours(0, 0, 0, 0);
    //     today.setHours(0, 0, 0, 0);

    //     if (date < today) {
    //         return "red.300";
    //     } else {
    //         return "yellow.300";
    //     }
    // };

    const getBgPrazoEnvio = (data) => {
        if (
            typeof data !== 'string' ||
            !data.includes(' ') ||
            data.split(' ').length < 2
        ) {
            return "gray.200";
        }

        try {
            // Parse data no formato "dd/MM/yyyy HH:mm" no timezone de São Paulo
            const prazo = DateTime.fromFormat(data, "dd/MM/yyyy HH:mm", { zone: "America/Sao_Paulo" });

            if (!prazo.isValid) {
                return "gray.200";
            }

            // Data e hora atual em São Paulo
            const agora = DateTime.now().setZone("America/Sao_Paulo");

            // Se o prazo já passou, retorna vermelho
            if (prazo < agora) {
                return "red.300";
            } else {
                return "yellow.300";
            }
        } catch (e) {
            return "gray.200";
        }
    };





    const getTextPedidoStatusTAGA = (pedido) => {
        if (pedido.status_taga == 1) { return "CONFIRMADA"; }
        if (pedido.status_taga == 2) { return "CANCELADA"; }
        if (pedido.status_taga == 3) { return "PENDENTE"; }
        return "";
    };

    const getBgBasedOnStatus = (status) => {
        if (status == "CONFIRMADA") {
            return "gray.600";
        } else if (status == "PARA ENVIAR") {
            return "yellow.200";
        } else if (status == "EM TRÂNSITO") {
            return "blue.500";
        } else if (status == "CONCLUÍDA") {
            return "green.500";
        } else if (status == "CANCELADA") {
            return "red.500";
        }
    };

    const getIconPedidoStatus = (status) => {
        if (status == "CONFIRMADA") {
            return <IoMdCart fontSize={"15px"} style={{ marginRight: "5px" }} />;
        } else if (status == "PARA ENVIAR") {
            return <GoPackage fontSize={"18px"} style={{ marginRight: "5px" }} />;
        } else if (status == "EM TRÂNSITO") {
            return <MdLocalShipping fontSize={"18px"} style={{ marginRight: "5px" }} />;
        } else if (status == "CONCLUÍDA") {
            return <FaCheckCircle fontSize={"15px"} style={{ marginRight: "5px" }} />;
        } else if (status == "CANCELADA") {
            return <MdCancel fontSize={"18px"} style={{ marginRight: "5px" }} />;
        }
    }

    const handleChangeAcaoIndiv = (idVenda, acao) => {
        //setCheckboxesState([idVenda]);
        handleChangeAcaoMassa({ target: { value: acao }, id_venda: idVenda });
    };

    const handleStatusTaga = (idVenda, status) => {
        const aplicarEfeitosStatusTaga = (pedido) => {
            const s = parseInt(status, 10);
            pedido.status_taga = s;
            if (s === 1) {
                pedido.furo_estoque = 0;
            }
            if (s === 3) {
                pedido.marcador = 2;
            }
        };

        if (Array.isArray(idVenda)) {
            setLoading(true);
            (async () => {
                try {
                    const promises = idVenda.map(async id => {
                        const response = await setStatusTaga(id, status);
                        if (response != false) {
                            const pedidoEncontrado = pedidos.find(pedido => pedido.id === id);
                            if (pedidoEncontrado) {
                                aplicarEfeitosStatusTaga(pedidoEncontrado);
                            }
                            return true;
                        } else {
                            toast({
                                title: `Erro ao alterar status TAGA`,
                                status: 'error',
                                isClosable: true,
                                duration: 100,
                            });
                            return false;
                        }
                    });

                    const results = await Promise.all(promises);
                    const todasAsRequisicoesForamConcluidasComSucesso = results.every(result => result === true);

                    if (todasAsRequisicoesForamConcluidasComSucesso) {
                        setLoading(false);
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                        setPedidos([...pedidos]);
                        toast({
                            title: `Status TAGA alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    }
                } catch (error) {
                    toast({
                        title: `Erro ao alterar status TAGA: ${error.message}`,
                        status: 'error',
                        isClosable: true,
                        duration: 100,
                    });
                    setLoading(false);
                }
            })();
        } else {
            setCheckboxesState([idVenda]);
            setMasterCheckbox(false);
            setLoading(true);
            try {
                (async () => {
                    const response = await setStatusTaga(idVenda, status);
                    if (response != false) {
                        toast({
                            title: `Status TAGA alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    } else {
                        toast({
                            title: `Erro ao alterar status TAGA`,
                            status: 'error',
                            isClosable: true,
                        })
                    }
                    setLoading(false);

                    const pedidoEncontrado = pedidos.find(pedido => pedido.id === idVenda);
                    if (pedidoEncontrado) {
                        aplicarEfeitosStatusTaga(pedidoEncontrado);
                        setPedidos([...pedidos]);
                    }
                    setTimeout(() => {
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                    }, 1000);
                })();
            }
            catch {
                toast({
                    title: `Erro ao alterar status TAGA`,
                    status: 'error',
                    isClosable: true,
                })
                setLoading(false);
                return false;
            }
        }
    };

    const handleMarcadorTaga = (idVenda, marcador) => {
        const aplicarEfeitosMarcador = (pedido) => {
            const m = parseInt(marcador, 10);
            pedido.marcador = m === 7 ? 0 : m;
            if (m === 0 || m === 7) {
                pedido.furo_estoque = 0;
                pedido.status_taga = 1;
            } else if (m === 1) {
                pedido.furo_estoque = 1;
                pedido.status_taga = 2;
            } else if (m === 2 || m === 6) {
                pedido.status_taga = 3;
            } else if (m === 3 || m === 4 || m === 5) {
                pedido.status_taga = 2;
            }
        };

        if (Array.isArray(idVenda)) {
            setLoading(true);
            (async () => {
                try {
                    const promises = idVenda.map(async id => {
                        const response = await setMarcadorVenda(id, marcador);
                        if (response != false) {
                            const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === id);
                            if (pedidoEncontrado) {
                                aplicarEfeitosMarcador(pedidoEncontrado);
                            }
                            return true;
                        } else {
                            toast({
                                title: `Erro ao alterar marcador da venda`,
                                status: 'error',
                                isClosable: true,
                                duration: 100,
                            });
                            return false;
                        }
                    });

                    const results = await Promise.all(promises);
                    const todasAsRequisicoesForamConcluidasComSucesso = results.every(result => result === true);

                    if (todasAsRequisicoesForamConcluidasComSucesso) {
                        setLoading(false);
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                        setPedidos([...pedidos]);
                        toast({
                            title: `Marcador alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    }
                } catch (error) {
                    toast({
                        title: `Erro ao alterar marcador da venda: ${error.message}`,
                        status: 'error',
                        isClosable: true,
                        duration: 100,
                    });
                    setLoading(false);
                }
            })();
        } else {
            setCheckboxesState([idVenda]);
            setMasterCheckbox(false);
            setLoading(true);
            try {
                (async () => {
                    const response = await setMarcadorVenda(idVenda, marcador);
                    if (response != false) {
                        toast({
                            title: `Marcador alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    } else {
                        toast({
                            title: `Erro ao alterar marcador da venda`,
                            status: 'error',
                            isClosable: true,
                        })
                    }
                    setLoading(false);

                    const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === idVenda);
                    if (pedidoEncontrado) {
                        aplicarEfeitosMarcador(pedidoEncontrado);
                        setPedidos([...pedidos]);
                    }
                    setTimeout(() => {
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                    }, 1000);
                })();
            }
            catch {
                toast({
                    title: `Erro ao alterar marcador da venda`,
                    status: 'error',
                    isClosable: true,
                })
                setLoading(false);
                return false;
            }
        }
    };

    const handleCotacaoVenda = (idVenda, status) => {
        var color = "red";
        if (status == 1) {
            color = "#01695E";
        }
        if (Array.isArray(idVenda)) {
            setLoadingMini(true);
            (async () => {
                try {
                    const promises = idVenda.map(async id => {
                        const response = await setVendaCotacao(id, status);
                        if (response != false) {
                            const pedidoEncontrado = pedidos.find(pedido => pedido.id === id);
                            if (pedidoEncontrado) {
                                pedidoEncontrado.cotada = status;
                            }
                            setTimeout(() => {
                                $('#pedido_status_cotacao_' + id).css('color', color);
                            }, 300);
                            return true;
                        } else {
                            toast({
                                title: `Erro ao alterar status da cotação`,
                                status: 'error',
                                isClosable: true,
                                duration: 100,
                            });
                            return false;
                        }
                    });

                    const results = await Promise.all(promises);
                    const todasAsRequisicoesForamConcluidasComSucesso = results.every(result => result === true);

                    if (todasAsRequisicoesForamConcluidasComSucesso) {
                        setLoadingMini(false);
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                        setPedidos([...pedidos]);
                        toast({
                            title: `Status da cotação alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    }
                } catch (error) {
                    toast({
                        title: `Erro ao alterar status da cotação: ${error.message}`,
                        status: 'error',
                        isClosable: true,
                        duration: 100,
                    });
                    setLoadingMini(false);
                }
            })();
        } else {
            setCheckboxesState([idVenda]);
            setMasterCheckbox(false);
            setLoadingMini(true);
            try {
                (async () => {
                    const response = await setVendaCotacao(idVenda, status);
                    if (response != false) {
                        toast({
                            title: `Status da cotação alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    } else {
                        toast({
                            title: `Erro ao alterar status da cotação`,
                            status: 'error',
                            isClosable: true,
                        })
                    }
                    setLoadingMini(false);

                    const pedidoEncontrado = pedidos.find(pedido => pedido.id === idVenda);
                    if (pedidoEncontrado) {
                        pedidoEncontrado.cotada = status;
                        setPedidos([...pedidos]);
                    }
                    setTimeout(() => {
                        //consultarVendas(true);
                        $('#pedido_status_cotacao_' + idVenda).css('color', color);
                        $('#pedido_status_cotacao_' + idVenda).addClass('custom-hover');

                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                    }, 1000);
                })();
            }
            catch {
                toast({
                    title: `Erro ao alterar status da cotação`,
                    status: 'error',
                    isClosable: true,
                })
                setLoadingMini(false);
                setTimeout(() => {
                    //consultarVendas(true);
                }, 6000);
                return false;
            }
        }
    };

    /* ── Furo de estoque por item ──────────────────────────────────────────
       O furo e do ITEM, nao do pedido. Pedido com mais de uma peca abre o
       seletor; pedido de uma peca so segue direto, como sempre foi. */

    const [modalFuroItens, setModalFuroItens] = useState(null);

    // Espelha MarcarVendaFuroEstoqueService::sincronizarVenda no estado local.
    const sincronizarFuroPedido = (pedido) => {
        const itens = pedido.produtos || [];
        const emFuro = itens.filter(p => Number(p.furo_estoque) === 1).length;

        pedido.furo_estoque = emFuro > 0 ? 1 : 0;
        if (emFuro > 0) {
            pedido.marcador = 1;
            pedido.status_taga = (itens.length > 0 && emFuro >= itens.length) ? 2 : 1;
        } else {
            if (Number(pedido.marcador) === 1) pedido.marcador = 0;
            if (Number(pedido.status_taga) === 2) pedido.status_taga = 1;
        }
        $('#pedido_furo_estoque_' + pedido.id).css('color', emFuro > 0 ? 'red' : 'gray');
    };

    const abrirModalFuroItens = (pedido) => {
        setModalFuroItens({
            pedidoId: pedido.id,
            selecionados: (pedido.produtos || [])
                .filter(p => Number(p.furo_estoque) === 1 && p.item_venda_id)
                .map(p => p.item_venda_id),
        });
    };

    const toggleItemFuro = (itemVendaId) => {
        setModalFuroItens(atual => {
            if (!atual) return atual;
            const jaTem = atual.selecionados.includes(itemVendaId);
            return {
                ...atual,
                selecionados: jaTem
                    ? atual.selecionados.filter(id => id !== itemVendaId)
                    : [...atual.selecionados, itemVendaId],
            };
        });
    };

    const confirmarFuroItens = async () => {
        const estado = modalFuroItens;
        if (!estado) return;

        const pedido = pedidos.find(p => p.id === estado.pedidoId);
        if (!pedido) { setModalFuroItens(null); return; }

        const alvo = estado.selecionados;
        const mudancas = (pedido.produtos || [])
            .filter(p => p.item_venda_id)
            .map(p => ({ produto: p, novo: alvo.includes(p.item_venda_id) ? 1 : 0 }))
            .filter(({ produto, novo }) => Number(produto.furo_estoque || 0) !== novo);

        if (mudancas.length === 0) { setModalFuroItens(null); return; }

        setModalFuroItens(null);
        setLoadingMini2(true);
        let falhas = 0;

        for (const { produto, novo } of mudancas) {
            const ok = await setFuroEstoqueVenda(pedido.id, novo, produto.item_venda_id);
            if (ok === false) { falhas++; continue; }
            produto.furo_estoque = novo;
        }

        sincronizarFuroPedido(pedido);
        setPedidos([...pedidos]);
        setLoadingMini2(false);

        toast({
            title: falhas > 0
                ? `${mudancas.length - falhas} item(ns) atualizados, ${falhas} falharam`
                : `Furo de estoque atualizado (${mudancas.length} item(ns))`,
            status: falhas > 0 ? 'warning' : 'success',
            isClosable: true,
        });
    };

    const handleFuroEstoqueVenda = (idVenda, status) => {
        // Um unico pedido com mais de uma peca: quem furou pode ser so uma delas.
        if (Array.isArray(idVenda) && idVenda.length === 1) {
            const alvo = pedidos.find(p => p.id === idVenda[0]);
            if (alvo && (alvo.produtos || []).filter(p => p.item_venda_id).length > 1) {
                abrirModalFuroItens(alvo);
                return;
            }
        }

        var color = "gray";
        var statusTaga = 1;
        var marcador = 0;
        if (status === 1) {
            color = "red";
            statusTaga = 2;
            marcador = 1;
        } else {
            status = 0;
        }


        if (Array.isArray(idVenda)) {
            setLoadingMini2(true);
            (async () => {
                try {
                    const promises = idVenda.map(async id => {
                        const response = await setFuroEstoqueVenda(id, status);
                        if (response != false) {
                            const pedidoEncontrado = pedidos.find(pedido => pedido.id === id);
                            if (pedidoEncontrado) {
                                (pedidoEncontrado.produtos || []).forEach(p => { p.furo_estoque = status; });
                                pedidoEncontrado.furo_estoque = status;
                                pedidoEncontrado.status_taga = statusTaga;
                                pedidoEncontrado.marcador = marcador;
                            }
                            setTimeout(() => {
                                $('#pedido_furo_estoque_' + id).css('color', color);
                            }, 300);
                            return true;
                        } else {
                            toast({
                                title: `Erro ao alterar status do estoque da venda`,
                                status: 'error',
                                isClosable: true,
                                duration: 100,
                            });
                            return false;
                        }
                    });

                    const results = await Promise.all(promises);
                    const todasAsRequisicoesForamConcluidasComSucesso = results.every(result => result === true);

                    if (todasAsRequisicoesForamConcluidasComSucesso) {
                        setLoadingMini2(false);
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                        setPedidos([...pedidos]);
                        toast({
                            title: `Status do estoque da venda alterado com sucesso`,
                            status: 'success',
                            isClosable: true,
                        })
                    }
                } catch (error) {
                    toast({
                        title: `Erro ao alterar status do estoque da venda: ${error.message}`,
                        status: 'error',
                        isClosable: true,
                        duration: 100,
                    });
                    setLoadingMini2(false);
                }
            })();
        } else {
            setCheckboxesState([idVenda]);
            setMasterCheckbox(false);
            setLoadingMini2(true);
            try {
                (async () => {
                    const response = await setFuroEstoqueVenda(idVenda, status);
                    if (response != false) {
                        toast({
                            title: `Status do estoque da venda alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    } else {
                        toast({
                            title: `Erro ao alterar status do estoque da venda`,
                            status: 'error',
                            isClosable: true,
                        })
                    }
                    setLoadingMini2(false);

                    const pedidoEncontrado = pedidos.find(pedido => pedido.id === idVenda);
                    if (pedidoEncontrado) {
                        (pedidoEncontrado.produtos || []).forEach(p => { p.furo_estoque = status; });
                        pedidoEncontrado.furo_estoque = status;
                        pedidoEncontrado.status_taga = statusTaga;
                        pedidoEncontrado.marcador = marcador;
                        setPedidos([...pedidos]);
                    }
                    setTimeout(() => {
                        $('#pedido_furo_estoque_' + idVenda).css('color', color);
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                    }, 1000);
                })();
            }
            catch {
                toast({
                    title: `Erro ao alterar status do estoque da venda`,
                    status: 'error',
                    isClosable: true,
                })
                setLoadingMini2(false);
                return false;
            }
        }
    };


    const handleClickCopyPedido = useCallback((id) => {
        navigator.clipboard.writeText(`${id}`);
        const checkIcon = ReactDOMServer.renderToString(<FaClipboardCheck fontSize="0.8rem" color="#136b19" />);
        $('#copy_pedido_' + id).html(checkIcon);
        setTimeout(() => {
            const copyIcon = ReactDOMServer.renderToString(<FaCopy fontSize="0.8rem" />);
            $('#copy_pedido_' + id).html(copyIcon);
        }, 1000);
    }, []);

    const handleClickCopyAnuncio = useCallback((id) => {
        navigator.clipboard.writeText(`${id}`);
        const checkIcon = ReactDOMServer.renderToString(<FaClipboardCheck fontSize="0.8rem" color="#136b19" />);
        $('#copy_anuncio_' + id).html(checkIcon);
        setTimeout(() => {
            const copyIcon = ReactDOMServer.renderToString(<FaCopy fontSize="0.8rem" />);
            $('#copy_anuncio_' + id).html(copyIcon);
        }, 1000);
    }, []);

    const handleChangeTextObs = useCallback((event) => {
        setTextObs(event.target.value);
    }, []);

    const handleAddObs = async (idVenda, texto, files) => {
        if (texto.length === 0 && files && files.length == 0) {
            toast({
                title: `ERRO: Digite uma Observação!`,
                status: 'error',
                isClosable: true,
            });
            return false;
        }

        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        const formData = new FormData();

        formData.append("id", idVenda);
        formData.append("id_user", user.id);
        formData.append("obs", texto);

        files.forEach((file, index) => {
            formData.append(`files[]`, file);
        });

        setLoading(true);
        try {
            const response = await criarObsVenda(formData);
            if (response !== false) {
                toast({
                    title: `Observação adicionada com sucesso!`,
                    status: 'success',
                    isClosable: true,
                });
                // Atualiza os pedidos com a nova observação
                setPedidos((prevPedidos) =>
                    prevPedidos.map((pedido) => {
                        if (pedido.id_taga === idVenda) {
                            const now = new Date();
                            const createdAt = now.toISOString();
                            const observacaoNew = {
                                id: response.observacao_id,
                                arquivos: response.arquivos,
                                observacao: texto,
                                usuario_id: user.id,
                                created_at: createdAt,
                            };
                            return {
                                ...pedido,
                                observacoes: [...pedido.observacoes, observacaoNew],
                            };
                        }
                        return pedido;
                    })
                );
            } else {
                toast({
                    title: `Erro ao adicionar observação.`,
                    status: 'error',
                    isClosable: true,
                });
            }
            setLoading(false);
        } catch {
            toast({
                title: `Erro ao adicionar observação.`,
                status: 'error',
                isClosable: true,
            });
            setLoading(false);
        }
    };
    const handleApagarObs = (idVenda, idObs) => {
        setLoading(true);
        try {
            (async () => {
                const response = await apagarObsVenda(idObs);
                if (response != false) {
                    toast({
                        title: `Observação apagada com sucesso!`,
                        status: 'success',
                        isClosable: true,
                    })
                    const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === idVenda);
                    if (pedidoEncontrado) {
                        const obs_pedidoIndex = pedidoEncontrado.observacoes.findIndex(obs => obs.id === idObs);
                        if (obs_pedidoIndex !== -1) {
                            pedidoEncontrado.observacoes.splice(obs_pedidoIndex, 1);
                        }
                        setPedidos([...pedidos]);
                    }
                } else {
                    toast({
                        title: `Erro ao apagar observação.`,
                        status: 'error',
                        isClosable: true,
                    })
                }
                setLoading(false);
            })();
        }
        catch {
            toast({
                title: `Erro ao apagar observação.`,
                status: 'error',
                isClosable: true,
            })
            setLoading(false);
        }
    };

    const apagaTextoObs = () => {
        setTextObs("");
    };

    const getImgUser = (usuario_id) => {
        var img = "user.png";
        if (usuario_id == 3) {
            img = "/gabriel_logo.webp";
        } else if (usuario_id == 5) {
            img = "/tilio_logo.webp";
        } else if (usuario_id == 6) {
            img = "/riccioppo_logo.webp";
        } else if (usuario_id == 7) {
            img = "/user.png";
        } else if (usuario_id == 8) {
            img = "/gabriel_valiente_logo.webp";
        } else if (usuario_id == 9) {
            img = "/emerson_vendedor_logo.webp";
        } else if (usuario_id == 10) {
            img = "/analuiza_logo.webp";
        }

        return img;
    };

    const getNomeUser = (usuario_id) => {
        var nome = "TAGA ADM";
        if (usuario_id == 3) {
            nome = "Gabriel Bahia";
        } else if (usuario_id == 5) {
            nome = "Tilio Marigo";
        } else if (usuario_id == 6) {
            nome = "Arthur Riccioppo";
        } else if (usuario_id == 7) {
            nome = "Suporte 1";
        } else if (usuario_id == 8) {
            nome = "Gabriel Valiente";
        } else if (usuario_id == 9) {
            nome = "Emerson Buzato";
        }
        return nome;
    };

    const getBgColorPopover = (obs) => {
        var color = "black";
        if (obs && obs.length > 0) {
            color = "#01695E";
        }
        return color;
    };

    const podeExcluirObs = (usuario_id) => {
        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        if (user.id == usuario_id) {
            return true;
        }
        return false;
    };

    const handleTextCotacao = (idVenda) => {
        let textCotacaoMorelate = "";
        let textCotacaoMorelateStr = "";
        let textCotacaoVannucci = "";
        let textCotacaoVannucciStr = "";
        let textCotacaoIsapa = "";
        let textCotacaoIsapaStr = "";
        let textCotacaoBrcompany = "";
        let textCotacaoBrcompanyStr = "";
        let textCotacaoLng = "";
        let textCotacaoLngStr = "";
        let textCotacaoCba = "";
        let textCotacaoCbaStr = "";
        let textCotacaoMsam = "";
        let textCotacaoMsamStr = "";
        let textCotacaoBlparts = "";
        let textCotacaoBlpartsStr = "";
        let contMorelate = 0;
        let contVannucci = 0;
        let contIsapa = 0;
        let contBrcompany = 0;
        let contLng = 0;
        let contCba = 0;
        let contMsam = 0;
        let contBlparts = 0;

        if (!Array.isArray(idVenda)) {
            setCheckboxesState([idVenda]);
            idVenda = [idVenda];
        }
        idVenda.map(id => {
            const pedidoEncontrado = pedidosFiltrados.find(pedido => pedido.id === id);
            if (pedidoEncontrado) {
                pedidoEncontrado.produtos && pedidoEncontrado.produtos.map(produto => {
                    let estoqueFisicoText = "";
                    if (produto.quantidade_taga > 0) {
                        estoqueFisicoText = " <span style='color: red;'><b>(" + produto.quantidade_taga + " - EM ESTOQUE TAGA";
                        if (produto?.local_estoque?.length > 0) {
                            estoqueFisicoText += " - " + produto.local_estoque;
                        }
                        estoqueFisicoText += ")</b></span> ";
                    }
                    if (produto.fornecedor === "MORELATE") {
                        contMorelate++;
                        let rowProduto = contMorelate + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoMorelate += rowProduto;

                        let rowProdutoString = contMorelate + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoMorelateStr += rowProdutoString;
                    }
                    if (produto.fornecedor === "VANNUCCI") {
                        contVannucci++;
                        let rowProduto = contVannucci + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoVannucci += rowProduto;

                        let rowProdutoString = contVannucci + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoVannucciStr += rowProdutoString;
                    }
                    if (produto.fornecedor === "ISAPA") {
                        contIsapa++;
                        // let rowProduto = contIsapa + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        // textCotacaoIsapa += rowProduto;
                        // let rowProdutoString = contIsapa + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        // textCotacaoIsapaStr += rowProdutoString;
                        let rowProduto = contIsapa + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo_fornecedor + "</b>(codigo ISAPA) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoIsapa += rowProduto;
                        let rowProdutoString = contIsapa + ")" + produto.quantidade + " und. - " + produto.codigo_fornecedor + "(codigo ISAPA) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoIsapaStr += rowProdutoString;
                    }
                    if (produto.fornecedor === "BRCOMPANY") {
                        contBrcompany++;
                        let rowProduto = contBrcompany + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoBrcompany += rowProduto;

                        let rowProdutoString = contBrcompany + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoBrcompanyStr += rowProdutoString;
                    }
                    if (produto.fornecedor === "LNG") {
                        contLng++;
                        let rowProduto = contLng + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoLng += rowProduto;

                        let rowProdutoString = contLng + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoLngStr += rowProdutoString;
                    }
                    if (produto.fornecedor === "CBA") {
                        contCba++;
                        let rowProduto = contCba + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoCba += rowProduto;

                        let rowProdutoString = contCba + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoCbaStr += rowProdutoString;
                    }
                    if (produto.fornecedor === "MSAM") {
                        contMsam++;
                        let rowProduto = contMsam + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoMsam += rowProduto;

                        let rowProdutoString = contMsam + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoMsamStr += rowProdutoString;
                    }
                    if (produto.fornecedor === "BLPARTS") {
                        contBlparts++;
                        let rowProduto = contBlparts + ")" + estoqueFisicoText + "<b>" + produto.quantidade + "</b> und. - <b>" + produto.codigo + "</b>(codigo global) - <b>" + produto.fabricante + "</b>(fabricante) - <b>" + produto.nome + "</b>(nome)<br>";
                        textCotacaoBlparts += rowProduto;

                        let rowProdutoString = contBlparts + ")" + produto.quantidade + " und. - " + produto.codigo + "(codigo global) - " + produto.fabricante + "(fabricante) - " + produto.nome + "(nome)" + "\n";
                        textCotacaoBlpartsStr += rowProdutoString;
                    }
                });
            }

        });
        setTextCotacaoMorelate(textCotacaoMorelate ? <div dangerouslySetInnerHTML={{ __html: textCotacaoMorelate }} /> : '');
        setTextCotacaoVannucci(textCotacaoVannucci ? <div dangerouslySetInnerHTML={{ __html: textCotacaoVannucci }} /> : '');
        setTextCotacaoIsapa(textCotacaoIsapa ? <div dangerouslySetInnerHTML={{ __html: textCotacaoIsapa }} /> : '');
        setTextCotacaoBrcompany(textCotacaoBrcompany ? <div dangerouslySetInnerHTML={{ __html: textCotacaoBrcompany }} /> : '');
        setTextCotacaoLng(textCotacaoLng ? <div dangerouslySetInnerHTML={{ __html: textCotacaoLng }} /> : '');
        setTextCotacaoCba(textCotacaoCba ? <div dangerouslySetInnerHTML={{ __html: textCotacaoCba }} /> : '');
        setTextCotacaoMsam(textCotacaoMsam ? <div dangerouslySetInnerHTML={{ __html: textCotacaoMsam }} /> : '');
        setTextCotacaoBlparts(textCotacaoBlparts ? <div dangerouslySetInnerHTML={{ __html: textCotacaoBlparts }} /> : '');
        setStringCotacaoMorelate(textCotacaoMorelateStr);
        setStringCotacaoVannucci(textCotacaoVannucciStr);
        setStringCotacaoIsapa(textCotacaoIsapaStr);
        setStringCotacaoBrcompany(textCotacaoBrcompanyStr);
        setStringCotacaoLng(textCotacaoLngStr);
        setStringCotacaoCba(textCotacaoCbaStr);
        setStringCotacaoMsam(textCotacaoMsamStr);
        setStringCotacaoBlparts(textCotacaoBlpartsStr);
    };

    const copiarCotacao = (text, fornecedor) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = text ? text : '';
        const cotacaoString = tempDiv.innerText || tempDiv.textContent || '';

        navigator.clipboard.writeText(`${cotacaoString}`);
        const checkIcon = ReactDOMServer.renderToString(<FaClipboardCheck fontSize="1rem" color="#136b19" />);
        $('#copy_cotacao_' + fornecedor).html(checkIcon);
        setTimeout(() => {
            const copyIcon = ReactDOMServer.renderToString(<FaCopy fontSize="1rem" />);
            $('#copy_cotacao_' + fornecedor).html(copyIcon);
        }, 1000);
    }


    const copiarTextAtalho = (text, number) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = text ? text : '';
        const textString = tempDiv.innerText || tempDiv.textContent || '';
        navigator.clipboard.writeText(`${textString}`);
        const checkIcon = ReactDOMServer.renderToString(<FaClipboardCheck fontSize="0.8rem" color="#136b19" />);
        $('#copy_text_msg_' + number).html(checkIcon);
        setTimeout(() => {
            const copyIcon = ReactDOMServer.renderToString(<FaCopy fontSize="0.8rem" />);
            $('#copy_text_msg_' + number).html(copyIcon);
        }, 1000);
    }

    const [menuVisivel, setMenuVisivel] = useState(false);

    // const handleSetMenuVisivel = (pedido_id) => {
    //     if (menuVisivel !== false) {
    //         setMenuVisivel(false);
    //     } else {
    //         setMenuVisivel(pedido_id);
    //     }
    // }

    const estiloPadraoP = {
        display: 'initial',
        marginBlockStart: 'initial',
        marginBlockEnd: 'initial',
        marginInlineStart: 'initial',
        marginInlineEnd: 'initial',
        unicodeBidi: 'initial'
    };

    const formataCreatedAt = (data) => {
        const date = new Date(data);
        const offset = -3 * 60;
        const brasiliaDate = new Date(date.getTime() + (offset + date.getTimezoneOffset()) * 60000);

        const day = brasiliaDate.getDate().toString().padStart(2, '0');
        const month = (brasiliaDate.getMonth() + 1).toString().padStart(2, '0');
        const year = brasiliaDate.getFullYear();
        const hours = brasiliaDate.getHours().toString().padStart(2, '0');
        const minutes = brasiliaDate.getMinutes().toString().padStart(2, '0');
        const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}`;
        return formattedDateTime;
    }

    const toggleMenu = useCallback((pedidoId) => {
        setMenuVisivel((prev) => prev === pedidoId ? false : pedidoId);
    }, []);

    const [isLoadingBtnAtt, setIsLoadingBtnAtt] = useState(false);
    const handleClickBtnAtt = () => {
        setIsLoadingBtnAtt(true);
        setLoading(true);
        try {
            (async () => {
                const responseVendas = await atualizarVendas();
                if (responseVendas != false) {
                    toast({
                        title: `Vendas atualizadas com sucesso. A página será recarregada...`,
                        status: 'success',
                        isClosable: true,
                    })
                    setTimeout(() => window.location.reload(), 3000);
                } else {
                    toast({
                        title: `Erro ao atualizar vendas. Tente novamente.`,
                        status: 'error',
                        isClosable: true,
                    })
                }
                setLoading(false);
                setIsLoadingBtnAtt(false)
            })();
        }
        catch {
            setLoading(false);
            setIsLoadingBtnAtt(false)
            toast({
                title: `Erro ao atualizar vendas. Tente novamente.`,
                status: 'error',
                isClosable: true,
            })
        }
    };


    function parseDataLimite(dataLimite) {
        let data = null;

        // Tenta "dd/MM/yyyy HH:mm"
        try {
            data = parse(dataLimite, "dd/MM/yyyy HH:mm", new Date(), { locale: ptBR });
            if (!isNaN(data)) return data;
        } catch { }

        // Tenta "dd/MM/yyyy"
        try {
            data = parse(dataLimite, "dd/MM/yyyy", new Date(), { locale: ptBR });
            if (!isNaN(data)) return data;
        } catch { }

        // Tenta "yyyy-MM-dd HH:mm:ss"
        try {
            data = parse(dataLimite, "yyyy-MM-dd HH:mm:ss", new Date(), { locale: ptBR });
            if (!isNaN(data)) return data;
        } catch { }

        // Tenta "yyyy-MM-dd"
        try {
            data = parse(dataLimite, "yyyy-MM-dd", new Date(), { locale: ptBR });
            if (!isNaN(data)) return data;
        } catch { }
        return new Date(dataLimite);
    }

    const [filtrosStatusTaga, setFiltrosStatusTaga] = useState([]);
    function toggleFiltroStatusTaga(filtro) {
        setFiltrosStatusTaga((prev) =>
            prev.includes(filtro)
                ? prev.filter((item) => item !== filtro)
                : [...prev, filtro]
        );
    }
    function limparFiltrosStatusTaga() {
        setFiltrosStatusTaga([]);
    }

    // Helpers para filtros rápidos
    const pedidoTemConferencia = (pedido, statusList) => {
        return produtosAtivos(pedido).some(p => statusList.includes(p.conferencia_status));
    };
    const pedidoTemEstoqueTaga = (pedido) => {
        return pedido.produtos?.some(p => p.quantidade_taga > 0);
    };
    const pedidoParcial = (pedido, campo) => {
        const e = pedido.extrato;
        return !!e && Number(e[campo]) > 0 && Number(e.cancelados) + Number(e.devolvidos) < Number(e.valor_bruto) - 0.005;
    };

    const pedidosFiltrados = useMemo(() => {
        return pedidos.filter((pedido) => {
            if (filtrosStatusTaga.length === 0) return true;

            // Agrupar filtros por categoria
            const filtrosStatus = filtrosStatusTaga.filter(f => [1, 2, 3].includes(f));
            const filtrosEnvio = filtrosStatusTaga.filter(f => [10, 11, 12].includes(f));
            const filtrosConf = filtrosStatusTaga.filter(f => [20, 21, 22].includes(f));
            const filtrosNfe = filtrosStatusTaga.filter(f => [30, 31, 32, 33].includes(f));
            const filtrosEstoque = filtrosStatusTaga.filter(f => [40].includes(f));
            const filtrosTipo = filtrosStatusTaga.filter(f => [50, 51, 52].includes(f));
            const filtrosItens = filtrosStatusTaga.filter(f => [60, 61].includes(f));

            // Dentro de cada grupo: OR (passa se bater com qualquer um)
            // Entre grupos: AND (precisa passar em todos os grupos ativos)

            const passaStatus = filtrosStatus.length === 0 || filtrosStatus.some((filtro) => {
                switch (filtro) {
                    case 1: return pedido.status_taga === 1;
                    case 2: return pedido.status_taga === 2;
                    case 3: return pedido.status_taga === 3;
                    default: return false;
                }
            });

            const passaEnvio = filtrosEnvio.length === 0 || filtrosEnvio.some((filtro) => {
                switch (filtro) {
                    case 10:
                        return [1, 2, 3, 4, 5, 6].includes(pedido.marcador);
                    case 11:
                        return pedido.envio?.data_limite_envio && (
                            isToday(parseDataLimite(pedido.envio.data_limite_envio)) ||
                            isBefore(parseDataLimite(pedido.envio.data_limite_envio), new Date())
                        ) && ["CONFIRMADA", "PARA ENVIAR"].includes(pedido.status) && [1, 3].includes(pedido.status_taga);
                    case 12:
                        return pedido.envio?.data_limite_envio &&
                            isBefore(parseDataLimite(pedido.envio.data_limite_envio), new Date()) &&
                            ["CONFIRMADA", "PARA ENVIAR"].includes(pedido.status);
                    default: return true;
                }
            });

            const passaConf = filtrosConf.length === 0 || filtrosConf.some((filtro) => {
                switch (filtro) {
                    case 20: return pedidoTemConferencia(pedido, [0]); // pendente
                    case 21: return pedidoTemConferencia(pedido, [1, 3, 4, 5]); // sucesso, embalado, enviado, ressalva
                    case 22: return pedidoTemConferencia(pedido, [2]); // problema
                    default: return false;
                }
            });

            const temEtiqueta = pedido.pode_imprimir_etiqueta === true || pedido.etiqueta_melhor_envio != null;
            const passaNfe = filtrosNfe.length === 0 || filtrosNfe.some((filtro) => {
                switch (filtro) {
                    case 30: return pedido.notaEmitida === true;
                    case 31: return !pedido.notaEmitida;
                    case 32: return temEtiqueta;
                    case 33: return !temEtiqueta;
                    default: return false;
                }
            });

            const passaEstoque = filtrosEstoque.length === 0 || pedidoTemEstoqueTaga(pedido);

            const passaTipo = filtrosTipo.length === 0 || filtrosTipo.some((filtro) => {
                switch (filtro) {
                    case 50: return pedido.flex === 1 || pedido.envio?.flex_ml === 1;
                    case 51: return pedido.envio?.modo_envio === 'Entrega a Combinar';
                    case 52: return pedido.origem === 'ECOMMERCE' || pedido.origem === 'TAGA' || pedido.envio?.modo_envio === 'Entrega a Combinar';
                    default: return false;
                }
            });

            const passaItens = filtrosItens.length === 0 || filtrosItens.some((filtro) => pedidoParcial(pedido, filtro === 60 ? 'cancelados' : 'devolvidos'));

            return passaStatus && passaEnvio && passaConf && passaNfe && passaEstoque && passaTipo && passaItens;
        });
    }, [pedidos, filtrosStatusTaga]);


    // Agrupa pedidosFiltrados por pack_id preservando a ordem original.
    // Pedidos sem pack_id (ou com pack_id solo) viram grupos de 1 item
    // e renderizam sem wrapper visual. Somente grupos com 2+ pedidos
    // recebem o tratamento visual de "pack".
    const pedidosAgrupados = useMemo(() => {
        if (!pedidosFiltrados) return null;
        const groups = [];
        const indexMap = {};
        let flatIdx = 0;

        pedidosFiltrados.forEach(pedido => {
            const key = pedido.pack_id
                ? `pack-${pedido.pack_id}`
                : `venda-${pedido.id_taga || pedido.id}-${flatIdx}`;

            if (indexMap[key] === undefined) {
                indexMap[key] = groups.length;
                groups.push({
                    key,
                    packId: pedido.pack_id || null,
                    items: [],
                });
            }
            groups[indexMap[key]].items.push({ pedido, flatIndex: flatIdx++ });
        });

        return groups.map(g => ({ ...g, isGroup: g.items.length > 1 }));
    }, [pedidosFiltrados]);
    // No celular a lista inteira derrubava a aba do Safari: 218 cards viram ~55 mil
    // nos de DOM e qualquer toque leva segundos. Renderiza por lote e cresce ao rolar.
    // Os dados continuam todos em pedidosFiltrados, entao filtros, contadores e acoes
    // em massa seguem valendo para a lista inteira. No desktop nada muda.
    const [gruposVisiveis, setGruposVisiveis] = useState(LOTE_CELULAR);
    const sentinelaRef = useRef(null);

    useEffect(() => {
        setGruposVisiveis(LOTE_CELULAR);
    }, [pedidosAgrupados]);

    const gruposRenderizados = useMemo(() => {
        if (!pedidosAgrupados) return null;
        return isMobile ? pedidosAgrupados.slice(0, gruposVisiveis) : pedidosAgrupados;
    }, [pedidosAgrupados, isMobile, gruposVisiveis]);

    const faltamGrupos = isMobile && pedidosAgrupados
        ? Math.max(0, pedidosAgrupados.length - gruposVisiveis)
        : 0;

    useEffect(() => {
        if (!faltamGrupos || !sentinelaRef.current) return;
        const observador = new IntersectionObserver(
            (entradas) => {
                if (entradas[0].isIntersecting) {
                    setGruposVisiveis((atual) => atual + LOTE_CELULAR);
                }
            },
            { rootMargin: "600px" }
        );
        observador.observe(sentinelaRef.current);
        return () => observador.disconnect();
    }, [faltamGrupos]);


    const totaisFiltradosTAGA = useMemo(() => {
        const totais = {
            taga_confirmadas: 0,
            taga_pendentes: 0,
            taga_canceladas: 0,
            total_vendas_enviar_hoje: 0,
            total_vendas_atrasadas: 0,
            total_vendas_problemas: 0,
            conf_pendente: 0,
            conf_sucesso: 0,
            conf_problema: 0,
            nfe_emitida: 0,
            nfe_pendente: 0,
            etiq_gerada: 0,
            etiq_pendente: 0,
            estoque_taga: 0,
            flex_ml: 0,
            entrega_combinar: 0,
            melhor_envio: 0,
            item_cancelado: 0,
            devolucao_parcial: 0,
        };

        pedidosFiltrados.forEach((pedido) => {
            if (pedido.status_taga === 1) totais.taga_confirmadas++;
            if (pedido.status_taga === 3) totais.taga_pendentes++;
            if (pedido.status_taga === 2) totais.taga_canceladas++;

            if (pedido.envio?.data_limite_envio) {
                const dataLimite = parseDataLimite(pedido.envio.data_limite_envio);
                const enviarHojeBool = (
                    isToday(dataLimite) || isBefore(dataLimite, new Date())
                ) && ["CONFIRMADA", "PARA ENVIAR"].includes(pedido.status) && [1, 3].includes(pedido.status_taga);
                if (enviarHojeBool) totais.total_vendas_enviar_hoje++;
                if (isBefore(dataLimite, new Date()) && ["CONFIRMADA", "PARA ENVIAR"].includes(pedido.status)) {
                    totais.total_vendas_atrasadas++;
                }
            }

            if ([1, 2, 3, 4, 5, 6].includes(pedido.marcador)) totais.total_vendas_problemas++;

            // Conferência
            const ativosConf = produtosAtivos(pedido);
            if (ativosConf.some(p => p.conferencia_status === 0)) totais.conf_pendente++;
            if (ativosConf.some(p => [1, 3, 4, 5].includes(p.conferencia_status))) totais.conf_sucesso++;
            if (ativosConf.some(p => p.conferencia_status === 2)) totais.conf_problema++;

            // NF-e
            if (pedido.notaEmitida) totais.nfe_emitida++;
            else totais.nfe_pendente++;

            // Etiqueta
            const temEtiq = pedido.pode_imprimir_etiqueta === true || pedido.etiqueta_melhor_envio != null;
            if (temEtiq) totais.etiq_gerada++;
            else totais.etiq_pendente++;

            // Estoque TAGA
            if (pedido.produtos?.some(p => p.quantidade_taga > 0)) totais.estoque_taga++;

            // Tipo envio
            if (pedido.flex === 1 || pedido.envio?.flex_ml === 1) totais.flex_ml++;
            if (pedido.envio?.modo_envio === 'Entrega a Combinar') totais.entrega_combinar++;
            if (pedido.origem === 'ECOMMERCE' || pedido.origem === 'TAGA' || pedido.envio?.modo_envio === 'Entrega a Combinar') totais.melhor_envio++;

            if (pedidoParcial(pedido, 'cancelados')) totais.item_cancelado++;
            if (pedidoParcial(pedido, 'devolvidos')) totais.devolucao_parcial++;
        });

        return totais;
    }, [pedidosFiltrados]);

    const [loadingItemsEtiqueta, setLoadingItemsEtiqueta] = useState({});
    const handleClickImprimirEtiqueta = useCallback((idVenda, tipo, idMkt) => {
        const pedido = findPedidoById(idVenda);
        if (!isPedidoConferidoParaDespacho(pedido)) {
            toastConferenciaPendente(idMkt ?? idVenda);
            return;
        }
        setLoadingItemsEtiqueta((prev) => ({ ...prev, [idVenda]: true }));
        imprimirEtiquetaMercadoLivre(idVenda, tipo, idMkt);
    }, []);


    const imprimirEtiquetaMercadoLivre = async (idVenda, tipo, idMkt) => {
        setLoadingItemsEtiqueta((prev) => ({ ...prev, [idVenda]: true }));
        try {
            const time = Math.floor(Date.now() / 1000);
            const consulta = `id=${idVenda}&tipo=${tipo}&id_processamento=${time}`;
            const responseEtiqueta = await imprimirEtiquetaML(consulta);

            if (!responseEtiqueta.status) {
                throw new Error(responseEtiqueta.error?.details || "Erro desconhecido");
            }

            const { data, contentType } = responseEtiqueta; // Pegando os dados e tipo de conteúdo
            let blob;
            let fileExtension;

            if (contentType.includes("application/pdf")) {
                blob = new Blob([data], { type: "application/pdf" });
                fileExtension = ".pdf";
            } else if (contentType.includes("application/zip")) {
                blob = new Blob([data], { type: "application/zip" });
                fileExtension = ".zip";
            } else {
                throw new Error("Formato de arquivo inesperado");
            }

            // Criando nome do arquivo com data e timestamp
            const dataAtual = new Date();
            const dia = String(dataAtual.getDate()).padStart(2, "0");
            const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
            const ano = dataAtual.getFullYear();
            const dataFormatada = `${dia}-${mes}-${ano}`;
            const fileName = `etiqueta_${idMkt}_${dataFormatada}_${time}${fileExtension}`;

            // Criando link de download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast({
                title: `Etiqueta ${fileExtension} baixada com sucesso!`,
                status: "success",
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: "Erro ao imprimir etiqueta",
                description: error.message || "Erro desconhecido",
                status: "error",
                isClosable: true,
            });
        } finally {
            setLoadingItemsEtiqueta((prev) => ({ ...prev, [idVenda]: false }));
        }
    };


    const [mensagensErroEtiquetaMassa, setMensagensErroEtiquetaMassa] = useState({});
    const [statusVendasEtiquetaMassa, setStatusVendasEtiquetaMassa] = useState({});
    const imprimirEtiquetasMassaMercadoLivre = async (idsVendasAux) => {
        let tipo = tipoEtiquetaMassa;
        let idsVendasStr = idsVendasAux.join(",");
        const time = Math.floor(Date.now() / 1000);

        try {
            const consulta = `id=${idsVendasStr}&tipo=${tipo}&id_processamento=${time}`;
            const responseEtiqueta = await imprimirEtiquetaML(consulta);

            if (!responseEtiqueta.status) {
                throw new Error(responseEtiqueta.error?.details || "Erro desconhecido");
            }

            const { data, contentType } = responseEtiqueta; // Pegando os dados e tipo de conteúdo
            let blob;
            let fileExtension;

            if (contentType.includes("application/pdf")) {
                blob = new Blob([data], { type: "application/pdf" });
                fileExtension = ".pdf";
            } else if (contentType.includes("application/zip")) {
                blob = new Blob([data], { type: "application/zip" });
                fileExtension = ".zip";
            } else {
                throw new Error("Formato de arquivo inesperado");
            }

            // Criando nome do arquivo com data e timestamp
            const dataAtual = new Date();
            const dia = String(dataAtual.getDate()).padStart(2, "0");
            const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
            const ano = dataAtual.getFullYear();
            const dataFormatada = `${dia}-${mes}-${ano}`;
            const fileName = `etiquetas_${dataFormatada}_${time}${fileExtension}`;

            // Criando link de download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast({
                title: `Etiqueta ${fileExtension} baixada com sucesso!`,
                status: "success",
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: "Erro ao imprimir etiqueta",
                description: error.message || "Erro desconhecido",
                status: "error",
                isClosable: true,
            });
        } finally {
            try {

                const consulta = `id_processamento=${time}`;
                const responseProcessamento = await consultarRetornoProcessamento(consulta);
                console.log("responseProcessamento = ", responseProcessamento);

                // Criar um objeto com as mensagens de erro e status das vendas
                const mensagensDeErro = {};
                const statusRetorno = {};

                responseProcessamento.data.forEach(item => {
                    const idTrimmed = item.id_entidade.trim();
                    mensagensDeErro[idTrimmed] = item.retorno;
                    statusRetorno[idTrimmed] = item.status.toLowerCase(); // Normaliza para minúsculas
                });

                const novosStatus = { ...statusVendasEtiquetaMassa };

                vendasSelecionadasImprimirEtiquetaMassa.forEach(venda => {
                    const vendaId = venda.id.trim(); // Remove espaços extras
                    if (statusRetorno[vendaId] === 'erro') {
                        novosStatus[vendaId] = 'ERRO';
                    } else if (statusRetorno[vendaId] === 'sucesso') {
                        novosStatus[vendaId] = 'CONCLUÍDO';
                    } else {
                        mensagensDeErro[vendaId] = "Sem Retorno da API";
                        novosStatus[vendaId] = 'ERRO';
                    }
                });
                setMensagensErroEtiquetaMassa(mensagensDeErro);
                setStatusVendasEtiquetaMassa(novosStatus);

            } catch (error) {

                const novosStatus = { ...statusVendasEtiquetaMassa };
                const mensagensDeErro = {};

                vendasSelecionadasImprimirEtiquetaMassa.forEach(venda => {
                    novosStatus[venda.id] = 'ERRO';
                    mensagensDeErro[venda.id] = "ERRO DESCONHECIDO";
                });

                setMensagensErroEtiquetaMassa(mensagensDeErro);
                setStatusVendasEtiquetaMassa(novosStatus);
            }
            setIsLoadingEtiquetaMassa(false);
        }
    };



    const [loadingItemsNFML, setloadingItemsNFML] = useState({});


    const [idVendaNF, setIdVendaNF] = useState(null);
    const [idMktNF, setIdMkt] = useState(null);
    const [isModalOpenConfirmNF, setIsModalOpenConfirmNF] = useState(false);
    const closeModalConfirmNF = () => setIsModalOpenConfirmNF(false);

    const [isModalNfeIndividualCorrectionOpen, setIsModalNfeIndividualCorrectionOpen] = useState(false);
    const [nfeIndividualCorrectionPayload, setNfeIndividualCorrectionPayload] = useState(null);
    const [nfeIndividualCorrectionTarget, setNfeIndividualCorrectionTarget] = useState({ id: null, idMkt: null });

    const handleNfeIndividualCorrectionInputChange = (section, field, value, subSection = null) => {
        setNfeIndividualCorrectionPayload(prev => {
            if (subSection) {
                return {
                    ...prev,
                    [section]: {
                        ...prev[section],
                        [subSection]: {
                            ...prev[section]?.[subSection],
                            [field]: value
                        }
                    }
                };
            } else {
                return {
                    ...prev,
                    [section]: {
                        ...prev[section],
                        [field]: value
                    }
                };
            }
        });
    };

    const openModalConfirmNF = useCallback((idVenda, idMkt) => {
        const pedido = findPedidoById(idVenda);
        if (!isPedidoConferidoParaDespacho(pedido)) {
            toastConferenciaPendente(idMkt ?? idVenda);
            return;
        }
        setIdVendaNF(idVenda);
        setIdMkt(idMkt);
        setIsModalOpenConfirmNF(true);
    }, []);
    const handleCancelNF = () => {
        setIdVendaNF(null);
        setIdMkt(null);
        closeModalConfirmNF();
    };

    const handleClickEmitirNFe = () => {
        closeModalConfirmNF();
        setloadingItemsNFML((prev) => ({ ...prev, [idVendaNF]: true }));
        emitirNotaFiscalMercadoLivre(idVendaNF, idMktNF);
    };

    const emitirNotaFiscalMercadoLivre = async (idVenda, idMkt, customPayload = null) => {
        setloadingItemsNFML((prev) => ({ ...prev, [idVenda]: true }));
        try {
            const time = Math.floor(Date.now() / 1000);

            const consulta = `id=${idVenda}&id_processamento=${time}`;

            const bodyData = customPayload
                ? { custom_payloads: { [idVenda]: customPayload } }
                : {};

            const responseNF = await emitirNfML(consulta, bodyData);

            if (responseNF.status == true) {
                toast({
                    title: `Nota Fiscal da venda ${idMkt} foi emitida com sucesso!`,
                    status: 'success',
                    isClosable: true,
                });

                setIsModalNfeIndividualCorrectionOpen(false);
                setNfeIndividualCorrectionPayload(null);
                setNfeIndividualCorrectionTarget({ id: null, idMkt: null });

                const pedidoEncontrado = pedidos.find(pedido => pedido.id === idMkt);
                if (pedidoEncontrado) {
                    pedidoEncontrado.notaEmitida = true;
                    setPedidos([...pedidos]);
                }

            } else {
                let errorMsg = "Erro ao processar NFe";
                let payloadRetornado = null;

                if (responseNF.error && Array.isArray(responseNF.error) && responseNF.error.length > 0) {
                    const erroItem = responseNF.error[0];

                    try {
                        const retornoObj = typeof erroItem.retorno === 'string'
                            ? JSON.parse(erroItem.retorno)
                            : erroItem.retorno;

                        if (retornoObj) {
                            if (retornoObj.payload) {
                                payloadRetornado = retornoObj.payload;
                                errorMsg = typeof retornoObj.mensagem === 'string'
                                    ? retornoObj.mensagem
                                    : (retornoObj.mensagem?.message || JSON.stringify(retornoObj.mensagem));
                            }
                            else if (retornoObj.message) {
                                errorMsg = retornoObj.message;
                            } else {
                                errorMsg = JSON.stringify(retornoObj);
                            }
                        }
                    } catch (e) {
                        errorMsg = String(erroItem.retorno);
                    }
                }

                toast({
                    title: `Erro ao emitir NFe`,
                    description: errorMsg,
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                });

                if (payloadRetornado) {
                    setNfeIndividualCorrectionPayload(payloadRetornado);
                    setNfeIndividualCorrectionTarget({ id: idVenda, idMkt: idMkt });
                    setIsModalNfeIndividualCorrectionOpen(true);
                }
            }
        } catch (error) {
            toast({
                title: `Erro ao emitir Nota Fiscal`,
                status: 'error',
                isClosable: true,
            });
        } finally {
            setloadingItemsNFML((prev) => ({ ...prev, [idVenda]: false }));
        }
    };

    const handleReenviarNfeIndividualComCorrecao = () => {
        if (!nfeIndividualCorrectionPayload || !nfeIndividualCorrectionTarget.id) return;

        emitirNotaFiscalMercadoLivre(
            nfeIndividualCorrectionTarget.id,
            nfeIndividualCorrectionTarget.idMkt,
            nfeIndividualCorrectionPayload
        );
    };


    const [tipoEtiquetaMassa, setTipoEtiquetaMassa] = useState('pdf');
    const handleTipoEtiquetaChange = (event) => {
        setTipoEtiquetaMassa(event.target.value);
    };

    const [isLoadingEtiquetaMassa, setIsLoadingEtiquetaMassa] = useState(false);
    const [vendasSelecionadasImprimirEtiquetaMassa, setVendasSelecionadasImprimirEtiquetaMassa] = useState([]);
    const [isModalOpenImprimirEtiquetasMassaML, setIsModalOpenImprimirEtiquetasMassaML] = useState(false);
    const closeModalImprimirEtiquetasMassaML = () => setIsModalOpenImprimirEtiquetasMassaML(false);
    const removerVendaImprimirEtiquetaMasas = (id) => {
        setVendasSelecionadasImprimirEtiquetaMassa((prevVendas) => {
            const novasVendas = prevVendas.filter(venda => venda.id !== id);
            if (novasVendas.length === 0) {
                handleCancelImprimirEtiquetasMassaML();
            }
            return novasVendas;
        });
        handleCheckboxChange(id);
    };
    const openModalImprimirEtiquetasMassaML = (IdVendasSelecionadas) => {
        let vendasSelecionadas = pedidos.filter(pedido =>
            IdVendasSelecionadas.includes(pedido.id) &&
            (pedido.origem === "Mercado Livre" || pedido.origem === "Mercado Shops")
        );

        setVendasSelecionadasImprimirEtiquetaMassa(vendasSelecionadas);
        setIsModalOpenImprimirEtiquetasMassaML(true);
    };

    const handleCancelImprimirEtiquetasMassaML = () => {
        closeModalImprimirEtiquetasMassaML();
        setVendasSelecionadasImprimirEtiquetaMassa([]);
        //setCheckboxesState([]);
        setStatusVendasEtiquetaMassa({});
        setIsLoadingEtiquetaMassa(false);
        setMensagensErroEtiquetaMassa({});
    };

    const handleClickImprimirEtiquetasMassaML = () => {
        const conferidas = vendasSelecionadasImprimirEtiquetaMassa.filter(v => isPedidoConferidoParaDespacho(v));
        const naoConferidas = vendasSelecionadasImprimirEtiquetaMassa.length - conferidas.length;

        if (conferidas.length === 0) {
            toast({
                title: "Nenhuma venda conferida",
                description: "Todas as vendas selecionadas ainda nao foram conferidas. Conclua a conferencia antes de imprimir etiquetas.",
                status: "warning",
                duration: 6000,
                isClosable: true,
            });
            return;
        }
        if (naoConferidas > 0) {
            toast({
                title: `${naoConferidas} venda(s) ignorada(s)`,
                description: "Apenas vendas ja conferidas serao processadas. As demais foram ignoradas.",
                status: "info",
                duration: 5000,
                isClosable: true,
            });
        }

        setIsLoadingEtiquetaMassa(true);
        const novasVendasStatus = conferidas.reduce((acc, venda) => {
            acc[venda.id] = 'PROCESSANDO';
            return acc;
        }, {});
        setStatusVendasEtiquetaMassa(novasVendasStatus);

        let vendasSelecionadasIds = conferidas.map(venda => venda.id_taga);
        imprimirEtiquetasMassaMercadoLivre(vendasSelecionadasIds);
    };


    /* INICIO - Emissão NFe Massa Mercado Livre */
    const [isModalOpenEmitirNfesMassaML, setIsModalOpenEmitirNfesMassaML] = useState(false);
    const [vendasSelecionadasEmitirNfeMassa, setVendasSelecionadasEmitirNfeMassa] = useState([]);
    const openModalEmitirNfesMassaML = (IdVendasSelecionadas) => {
        let vendasSelecionadas = pedidos.filter(pedido =>
            IdVendasSelecionadas.includes(pedido.id) &&
            (pedido.origem === "Mercado Livre" || pedido.origem === "Mercado Shops")
        );
        const conferidas = vendasSelecionadas.filter(v => isPedidoConferidoParaDespacho(v));
        const naoConferidas = vendasSelecionadas.length - conferidas.length;

        if (conferidas.length === 0) {
            toast({
                title: "Nenhuma venda conferida",
                description: "Todas as vendas selecionadas ainda nao foram conferidas. Conclua a conferencia antes de emitir NFe.",
                status: "warning",
                duration: 6000,
                isClosable: true,
            });
            return;
        }
        if (naoConferidas > 0) {
            toast({
                title: `${naoConferidas} venda(s) ignorada(s)`,
                description: "Apenas vendas ja conferidas serao processadas. As demais foram ignoradas.",
                status: "info",
                duration: 5000,
                isClosable: true,
            });
        }

        setVendasSelecionadasEmitirNfeMassa(conferidas);
        setIsModalOpenEmitirNfesMassaML(true);
    };
    /* FIM - Emissão NFe Massa Mercado Livre */


    const handleStatusVenda = (idVenda, status) => {
        var statusTexto = "confirmada";
        if (status == "PARA ENVIAR") {
            statusTexto = "enviar";
        } else if (status == "EM TRÂNSITO") {
            statusTexto = "transito";
        } else if (status == "CONCLUÍDA") {
            statusTexto = "concluida";
        } else if (status == "CANCELADA") {
            statusTexto = "cancelada";
        }
        if (Array.isArray(idVenda)) {
            setLoading(true);
            (async () => {
                try {
                    const promises = idVenda.map(async id => {
                        const response = await setStatusVenda(id, statusTexto);
                        if (response != false) {
                            const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === id);
                            if (pedidoEncontrado) {
                                pedidoEncontrado.status = status;
                            }
                            return true;
                        } else {
                            toast({
                                title: `Erro ao alterar status da venda`,
                                status: 'error',
                                isClosable: true,
                                duration: 100,
                            });
                            return false;
                        }
                    });

                    const results = await Promise.all(promises);
                    const todasAsRequisicoesForamConcluidasComSucesso = results.every(result => result === true);

                    if (todasAsRequisicoesForamConcluidasComSucesso) {
                        setLoading(false);
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                        setIdVendaSetStatus(null);
                        setValorStatusVenda("");
                        setPedidos([...pedidos]);
                        toast({
                            title: `Status alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    }
                } catch (error) {
                    toast({
                        title: `Erro ao alterar status da venda: ${error.message}`,
                        status: 'error',
                        isClosable: true,
                        duration: 100,
                    });
                    setLoading(false);
                    setIdVendaSetStatus(null);
                    setValorStatusVenda("");
                }
            })();
        } else {
            setCheckboxesState([idVenda]);
            setMasterCheckbox(false);
            setLoading(true);
            try {
                (async () => {
                    const response = await setStatusVenda(idVenda, statusTexto);
                    if (response != false) {
                        toast({
                            title: `Status alterado com sucesso!`,
                            status: 'success',
                            isClosable: true,
                        })
                    } else {
                        toast({
                            title: `Erro ao alterar status da venda`,
                            status: 'error',
                            isClosable: true,
                        })
                    }
                    setLoading(false);

                    const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === idVenda);
                    if (pedidoEncontrado) {
                        pedidoEncontrado.status = status;
                        setPedidos([...pedidos]);
                    }
                    setTimeout(() => {
                        setCheckboxesState([]);
                        setMasterCheckbox(false);
                        setIdVendaSetStatus(null);
                        setValorStatusVenda("");
                    }, 1000);
                })();
            }
            catch {
                toast({
                    title: `Erro ao alterar status da venda`,
                    status: 'error',
                    isClosable: true,
                })
                setLoading(false);
                setIdVendaSetStatus(null);
                setValorStatusVenda("");
                return false;
            }
        }
    };

    const [expandedProducts, setExpandedProducts] = useState(new Set());
    const handleToggleProductDetails = (pedidoId, produtoId) => {
        const uniqueKey = `${pedidoId}-${produtoId}`;
        setExpandedProducts(prevExpanded => {
            const newExpanded = new Set(prevExpanded);
            if (newExpanded.has(uniqueKey)) {
                newExpanded.delete(uniqueKey);
            } else {
                newExpanded.add(uniqueKey);
            }
            return newExpanded;
        });
    };
    const isProductExpanded = (pedidoId, produtoId) => {
        const uniqueKey = `${pedidoId}-${produtoId}`;
        return expandedProducts.has(uniqueKey);
    };


    const [isModalNfeTagaOpen, setIsModalNfeTagaOpen] = useState(false);
    const [loadingNfeTaga, setLoadingNfeTaga] = useState(false);
    const [nfeTagaResult, setNfeTagaResult] = useState(null);
    const [nfeTagaErrorDetail, setNfeTagaErrorDetail] = useState(null);
    const [isEditingNfePayload, setIsEditingNfePayload] = useState(false);
    const [editablePayload, setEditablePayload] = useState(null);
    const [isModalConfirmNfeTagaOpen, setIsModalConfirmNfeTagaOpen] = useState(false);
    const [vendaIdParaEmitirNfe, setVendaIdParaEmitirNfe] = useState(null);
    const [currentNfeVendaId, setCurrentNfeVendaId] = useState(null);
    const [downloadingNfeType, setDownloadingNfeType] = useState(null);

    const openModalConfirmNfeTaga = useCallback((idVenda) => {
        const pedido = findPedidoById(idVenda);
        if (!isPedidoConferidoParaDespacho(pedido)) {
            toastConferenciaPendente(pedido?.id ?? idVenda);
            return;
        }
        setVendaIdParaEmitirNfe(idVenda);
        setIsModalConfirmNfeTagaOpen(true);
    }, []);

    const closeModalConfirmNfeTaga = () => {
        setVendaIdParaEmitirNfe(null);
        setIsModalConfirmNfeTagaOpen(false);
    };

    const handleConfirmEmitirNfeTaga = () => {
        if (vendaIdParaEmitirNfe) {
            handleEmitirNfeTaga(vendaIdParaEmitirNfe);
            closeModalConfirmNfeTaga();
        }
    };

    const handleCloseModalNfeTaga = () => {
        setIsModalNfeTagaOpen(false);
        setNfeTagaResult(null);
        setNfeTagaErrorDetail(null);
        setIsEditingNfePayload(false);
        setEditablePayload(null);
        setCurrentNfeVendaId(null);
    };

    const handleEmitirNfeTaga = async (idVenda, payloadOverride = null) => {
        if (idVenda) {
            setCurrentNfeVendaId(idVenda);
        }

        setLoadingNfeTaga(true);

        if (!payloadOverride) {
            setNfeTagaResult(null);
            setNfeTagaErrorDetail(null);
            setIsEditingNfePayload(false);
        }

        setIsModalNfeTagaOpen(true);
        setMenuVisivel(false);

        const response = await emitirNfeTaga(idVenda, payloadOverride);

        setLoadingNfeTaga(false);
        setIsEditingNfePayload(false);

        if (response && response.status === 200 && response.data.success) {
            setNfeTagaResult(response.data);

            toast({
                title: "Sucesso!",
                description: "Nota Fiscal emitida e autorizada.",
                status: "success",
                duration: 3000,
                isClosable: true,
            });

            const pedidoIndex = pedidos.findIndex(p => p.id_taga === idVenda);
            if (pedidoIndex >= 0) {
                const novosPedidos = [...pedidos];
                novosPedidos[pedidoIndex].notaEmitida = true;
                setPedidos(novosPedidos);
            }

        } else {
            const errorData = response?.data || { error: "Erro desconhecido de comunicação" };
            setNfeTagaResult({ success: false });
            setNfeTagaErrorDetail(errorData);

            if (errorData.submitted_payload) {
                setEditablePayload(errorData.submitted_payload);
            }

            toast({
                title: "Erro na Emissão",
                description: "Verifique os detalhes no modal.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    const handleResendEditedNfe = () => {
        if (currentNfeVendaId && editablePayload) {
            handleEmitirNfeTaga(currentNfeVendaId, editablePayload);
        }
    };

    const handleSimpleRetryNfe = () => {
        if (currentNfeVendaId) {
            handleEmitirNfeTaga(currentNfeVendaId, null);
        }
    };

    const handlePayloadChange = (section, field, value) => {
        setEditablePayload(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const handleItemChange = (index, field, value) => {
        setEditablePayload(prev => {
            const newItems = [...prev.items];
            newItems[index] = {
                ...newItems[index],
                [field]: value
            };
            return { ...prev, items: newItems };
        });
    };

    const handleResendNfeTaga = () => {
        if (editablePayload && editablePayload.orderNumber) {
            handleEmitirNfeTaga(editablePayload.orderNumber, editablePayload);
        }
    };

    const handleActivateEditMode = () => {
        setIsEditingNfePayload(true);
    };

    const handleDownloadArquivoNfe = async (nfeId, type) => {
        setDownloadingNfeType(type);

        try {
            const url = `/nfe/${type}/${nfeId}`;
            const response = await downloadNfeArquivo(url);

            if (response) {
                const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = urlBlob;
                link.setAttribute('download', `nfe_${nfeId}.${type === 'danfe' ? 'pdf' : 'xml'}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                toast({
                    title: "Erro no download",
                    description: "Não foi possível baixar o arquivo.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            console.error("Erro download:", error);
            toast({
                title: "Erro ao processar download",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setDownloadingNfeType(null);
        }
    };

    const propsDoCard = (pedido, index, isInPackGroup) => ({
        pedido,
        onOcorrenciasAlteradas: () => consultarVendas(false),
        index,
        isMobile,
        cotacaoStatus: cotacoesStatusByVenda[pedido.id],
        marcador: pedido.marcador,
        cotada: pedido.cotada,
        furo_estoque: pedido.furo_estoque,
        status_taga: pedido.status_taga,
        status: pedido.status,
        notaEmitida: pedido.notaEmitida,
        observacoes: pedido.observacoes,
        checkboxesState,
        menuVisivel,
        textObs,
        openPedidosFooter,
        loadingItemsEtiqueta,
        loadingItemsNFML,
        loadingMini,
        handleCheckboxChange,
        toggleMenu,
        handleChangeTextObs,
        toggleAccordionPedidosFooter,
        handleCotacaoVenda,
        handleChangeAcaoIndiv,
        openTicketModal,
        handleAddObs,
        handleApagarObs,
        handleMarcadorTaga,
        consultarMensagensVendas,
        naoLidasPorPackId,
        openModalViewPedido,
        openModalViewPedidoTaga,
        handleClickCopyPedido,
        handleClickCopyAnuncio,
        handleClickImprimirEtiqueta,
        openModalConfirmNF,
        openModalConfirmNfeTaga,
        checkPermission,
        checkPermissionUser,
        isLastItem: index === pedidosFiltrados.length - 1,
        isInPackGroup,
    });

    return (
        <>
            <ScrollToTop />
            {loading && <Preloader />}
            <Box ml={{ base: "0", md: "8" }} textAlign="center" fontSize="xl" py={2} bg={usarCardV2 ? "#EEF1F5" : "white"} minH="100vh">
                <Box textAlign="center" ml={4} mb={0} fontSize="xl">
                    <Text color={"#F68633"} fontWeight={"bold"}>
                        VENDAS
                    </Text>
                </Box>

                {/* Container Central - Deixei menor (w=85% a 95%) para respeitar a sidebar */}
                <Box mx={{ base: 1, md: 12, lg: 18 }} mt={0} px={0} mb={{ base: "2", md: "8", lg: "10" }} pb={12} justifyItems={"center"}>
                    <VStack spacing={2} align="center" w={{ base: "100%", md: "100%", lg: "95%", xl: "85%" }} mx="auto">

                        {/* ENVELOPE DOS FILTROS: Usa exatamente as mesmas margens e larguras da sua barra de Ações em Massa */}
                        <Box {...larguraTopo}>
                            <StatusVendasMktplaces
                                v2={usarCardV2}
                                totalVendas={totalVendas}
                                totalVendasTAGA={totalVendasTAGA}
                                isOpenStatusMkt={isOpenStatusMkt}
                                toggleDropdownStatusMkt={toggleDropdownStatusMkt}
                                data_inicio={filtroDataInicial}
                                data_fim={filtroDataFinal}
                                dataUltimaAtualizacaoVendas={dataUltimaAtualizacaoVendas}
                            />
                            <FiltrosVendas
                                v2={usarCardV2}
                                filtroBusca={filtroBusca}
                                handleChangeFiltroBusca={handleChangeFiltroBusca}
                                filtroDataInicial={filtroDataInicial}
                                handleChangeFiltroDataInicial={handleChangeFiltroDataInicial}
                                filtroDataFinal={filtroDataFinal}
                                handleChangeFiltroDataFinal={handleChangeFiltroDataFinal}
                                selectedOptionsStatus={selectedOptionsStatus}
                                handleSelectedOptionsStatusChange={handleSelectedOptionsStatusChange}
                                selectedOptionsMktplaces={selectedOptionsMktplaces}
                                handleSelectedOptionsMktplaces={handleSelectedOptionsMktplaces}
                                selectedOptionsStatusFornecedor={selectedOptionsStatusFornecedor}
                                handleSelectedOptionsFornecedoresChange={handleSelectedOptionsFornecedoresChange}
                                handlePesquisar={handlePesquisar}
                                limparFiltros={limparFiltros}
                            />
                            <StatusVendasTaga
                                v2={usarCardV2}
                                totalVendasTAGA={totaisFiltradosTAGA}
                                filtrosStatusTaga={filtrosStatusTaga}
                                toggleFiltroStatusTaga={toggleFiltroStatusTaga}
                                limparFiltrosStatusTaga={limparFiltrosStatusTaga}
                            />
                        </Box>

                        {
                            buscaBool && !loading &&
                            <Alert status='warning' {...larguraTopo} borderRadius="lg">
                                <AlertIcon />
                                <AlertTitle>Nenhum registro encontrado!</AlertTitle>
                            </Alert>
                        }

                        {
                            buscaAmpliada && !loading &&
                            <Alert status='info' {...larguraTopo} borderRadius="lg">
                                <AlertIcon />
                                <AlertTitle fontSize="13px" fontWeight="600">
                                    Nada encontrado no período e status filtrados. Mostrando resultados de todo o histórico.
                                </AlertTitle>
                            </Alert>
                        }

                        <Box w={"100%"}>
                            {loadingLinear && <Progress mb={0} size='xs' isIndeterminate colorScheme="orange" />}

                            <Flex as="label" display={{ base: "flex", md: "none" }} justify="flex-end" align="center" mb={1} cursor="pointer">
                                <Text fontSize="10px" fontWeight="bold" mr={2} color={usarCardV2 ? "gray.600" : "black"} whiteSpace="nowrap">V2</Text>
                                <Switch size="sm" colorScheme="orange" isChecked={usarCardV2} onChange={(e) => setUsarCardV2(e.target.checked)} />
                            </Flex>
                            {usarCardV2 && (
                                <Flex display={{ base: "flex", md: "none" }} justify="center" mb={2}>
                                    <AlternarVisao kanban={visaoKanban} onChange={setVisaoKanban} />
                                </Flex>
                            )}
                            {/* BARRA DE AÇÕES EM MASSA (100% ORIGINAL, com o switch ao lado do checkbox) */}
                            <Flex justifyContent={"center"} mb={1}>
                                <Box {...larguraTopo} boxShadow={usarCardV2 ? SOMBRA : 'md'} justifyItems={"center"} borderRadius={usarCardV2 ? "xl" : "lg"} bg={usarCardV2 ? "white" : "#FF9F59"}
                                    border={usarCardV2 ? "1px solid" : undefined} borderColor={usarCardV2 ? "gray.200" : undefined} px={usarCardV2 ? 2 : undefined}>
                                    <Flex w={"100%"} flexDirection={"row"} justify={"space-between"} align="center">

                                        {/* INÍCIO DO LADO ESQUERDO */}
                                        <Flex align="center">
                                            <Checkbox size={isMobile ? "lg" : "md"} isChecked={masterCheckbox} m={1} onChange={handleMasterCheckboxChange}></Checkbox>

                                            {/* Contador e Limpar */}
                                            {checkboxesState.length > 0 && (
                                                <Flex align="center" ml={2} display={{ base: "none", md: "flex" }}>
                                                    <Text fontSize="12px" fontWeight="bold" mr={2} color="black">{checkboxesState.length} Selecionado(s)</Text>
                                                    <Button size="xs" colorScheme="red" onClick={handleClearSelection}>Limpar</Button>
                                                </Flex>
                                            )}

                                            <Flex as="label" align="center" ml={4} bg={usarCardV2 ? "gray.50" : "whiteAlpha.500"} border={usarCardV2 ? "1px solid" : undefined} borderColor="gray.200" px={2} py={1} borderRadius="md" cursor="pointer" display={{ base: "none", md: "flex" }}>
                                                <Text fontSize="10px" fontWeight="bold" mr={2} color={usarCardV2 ? "gray.600" : "black"} whiteSpace="nowrap">V2</Text>
                                                <Switch size="sm" colorScheme="orange" isChecked={usarCardV2} onChange={(e) => setUsarCardV2(e.target.checked)} />
                                            </Flex>
                                            {usarCardV2 && (
                                                <Box ml={3} display={{ base: "none", md: "block" }}>
                                                    <AlternarVisao kanban={visaoKanban} onChange={setVisaoKanban} />
                                                </Box>
                                            )}
                                        </Flex>
                                        {/* FIM DO LADO ESQUERDO */}

                                        {
                                            checkPermissionUser("vendas_acoes_massa") && (
                                                <Flex>
                                                    <Flex justify={"center"} textAlign={"center"} align={"center"}>
                                                        {usarCardV2
                                                            ? <Text m={1} {...ROTULO_SECAO} color="gray.500">Ações em massa</Text>
                                                            : <Text m={1} fontSize={{ base: "10px", md: "10px", lg: "14px" }} fontWeight="bold">{"AÇÕES EM MASSA"}</Text>}
                                                    </Flex>
                                                    <Box p={0} m={2}>
                                                        <Select
                                                            w={{ base: "200px", md: "200px", lg: "300px" }}
                                                            ml={2}
                                                            bg={"white"}
                                                            size={usarCardV2 ? "sm" : undefined}
                                                            borderRadius={usarCardV2 ? "md" : undefined}
                                                            borderColor={usarCardV2 ? "gray.200" : undefined}
                                                            fontSize={usarCardV2 ? "13px" : undefined}
                                                            value={selecaoMassa}
                                                            onChange={handleChangeAcaoMassa}
                                                            textAlign={"center"}
                                                        >
                                                            <option selected value="selecione">Selecione</option>
                                                            <div style={{ width: '100%', borderBottom: '1px solid black', margin: '8px 0' }}></div>
                                                            <option disabled value="selecione" style={{ color: "black", backgroundColor: "yellow", fontWeight: "bold", textAlign: "center", marginRight: "20px" }}>MERCADO LIVRE</option>
                                                            {checkPermissionUser("vendas_acao_massa_imprimir_etiquetas_ml") && <option value="imprimir_etiquetas_ml">Imprimir Etiquetas</option>}
                                                            {checkPermissionUser("vendas_acao_massa_emitir_nfs_ml") && <option value="emitir_nfes_ml">Emitir Notas Fiscais</option>}
                                                            {checkPermission() && (
                                                                <>
                                                                    <option disabled value="selecione" style={{ color: "black", backgroundColor: "#ababab", fontWeight: "bold", textAlign: "center", marginRight: "20px" }}>Cotação</option>
                                                                    <option value="lista_cotacao">Gerar lista</option>
                                                                    <option value="set_cotacao_sim">Marcar Cotada(s)</option>
                                                                    <option value="set_cotacao_nao">Desmarcar Cotada(s)</option>
                                                                    <option disabled value="selecione" style={{ color: "black", backgroundColor: "#ababab", fontWeight: "bold", textAlign: "center", marginRight: "20px" }}>Furo de Estoque</option>
                                                                    <option value="set_furo_estoque_sim">Marcar Furo de Estoque</option>
                                                                    <option value="set_furo_estoque_nao">Desmarcar Furo de Estoque</option>
                                                                    <option disabled value="selecione" style={{ color: "black", backgroundColor: "#ababab", fontWeight: "bold", textAlign: "center", marginRight: "20px" }}>Status TAGA</option>
                                                                    <option style={{ color: "#1ab000" }} value="set_status_taga_sim">CONFIRMADA</option>
                                                                    <option style={{ color: "red" }} value="set_status_taga_nao">CANCELADA</option>
                                                                    <option style={{ color: "#c7c106" }} value="set_status_taga_pen">PENDENTE</option>
                                                                </>
                                                            )}
                                                        </Select>
                                                    </Box>
                                                </Flex>
                                            )
                                        }
                                    </Flex>
                                </Box>
                            </Flex>
                            {mostrarKanban ? (
                                <VendasKanban pedidos={pedidosFiltrados} isMobile={isMobile} checkboxesState={checkboxesState} onSelecionar={handleCheckboxChange} renderVenda={(pedido, fechar) => <VendaCardV2 key={pedido.id} {...propsDoCard(pedido, pedidosFiltrados.indexOf(pedido), false)} somenteFicha onFecharFicha={fechar} />} />
                            ) : (
                            <Box maxW="100%" pt={usarCardV2 ? 2 : undefined}>
                                {gruposRenderizados && gruposRenderizados.map((group) => (
                                    <Box
                                        key={group.key}
                                        position="relative"
                                        {...(group.isGroup ? {
                                            mt: 6,
                                            mb: 4,
                                            p: { base: 2, md: 3 },
                                            pt: { base: 5, md: 6 },
                                            borderWidth: '2px',
                                            borderColor: 'blue.300',
                                            borderStyle: 'solid',
                                            borderRadius: 'lg',
                                            bg: 'blue.50',
                                        } : {})}
                                    >
                                        {group.isGroup && (
                                            <Box
                                                position="absolute"
                                                top="-12px"
                                                left="12px"
                                                bg="blue.500"
                                                color="white"
                                                px={3}
                                                py={1}
                                                borderRadius="md"
                                                fontSize="xs"
                                                fontWeight="bold"
                                                boxShadow="sm"
                                                zIndex={1}
                                            >
                                                PACK: #{group.packId} ({group.items.length} pedidos)
                                            </Box>
                                        )}
                                        {group.items.map(({ pedido, flatIndex: index }) => (
                                            <CardVenda
                                                key={pedido.id}
                                                {...propsDoCard(pedido, index, group.isGroup)}
                                            />
                                        ))}
                                    </Box>
                                ))}
                                {faltamGrupos > 0 && (
                                    <Flex ref={sentinelaRef} direction="column" align="center" py={6} gap={2}>
                                        <Spinner size="sm" color="orange.400" />
                                        <Text fontSize="xs" color="gray.500">
                                            carregando mais {Math.min(LOTE_CELULAR, faltamGrupos)} de {faltamGrupos} restantes
                                        </Text>
                                    </Flex>
                                )}
                                {isMobile && pedidosAgrupados && pedidosAgrupados.length > 0 && faltamGrupos === 0 && pedidosAgrupados.length > LOTE_CELULAR && (
                                    <Text fontSize="xs" color="gray.500" textAlign="center" py={4}>
                                        fim da lista, {pedidosAgrupados.length} vendas
                                    </Text>
                                )}
                            </Box>
                            )}
                        </Box>
                    </VStack>
                </Box>
            </Box>

            {/* --- MODAL DE CORREÇÃO INDIVIDUAL DE NFE --- */}
            <Modal isOpen={isModalNfeIndividualCorrectionOpen} onClose={() => setIsModalNfeIndividualCorrectionOpen(false)} size="xl" scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Corrigir Dados da Nota Fiscal</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Box bg="red.50" p={3} mb={4} borderRadius="md" borderLeft="4px solid" borderColor="red.400">
                            <Text fontSize="sm" color="red.800">
                                <b>Atenção:</b> A emissão falhou com os dados originais. Corrija os campos abaixo e tente novamente.
                            </Text>
                        </Box>

                        {nfeIndividualCorrectionPayload && (
                            <VStack spacing={5} align="stretch">
                                {/* Seção Cliente */}
                                <Box>
                                    <Text fontWeight="bold" mb={2} color="blue.600">Dados do Cliente</Text>
                                    <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                        <GridItem colSpan={2}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Nome / Razão Social</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.customer?.name || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('customer', 'name', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem>
                                            <FormControl>
                                                <FormLabel fontSize="sm">CPF / CNPJ</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.customer?.document?.number || nfeIndividualCorrectionPayload.customer?.cpf || nfeIndividualCorrectionPayload.customer?.cnpj || ''}
                                                    onChange={(e) => {
                                                        if (nfeIndividualCorrectionPayload.customer?.document) {
                                                            handleNfeIndividualCorrectionInputChange('customer', 'number', e.target.value, 'document');
                                                            const type = e.target.value.replace(/\D/g, '').length > 11 ? 'CNPJ' : 'CPF';
                                                            handleNfeIndividualCorrectionInputChange('customer', 'type', type, 'document');
                                                        } else {
                                                            handleNfeIndividualCorrectionInputChange('customer', 'cpf', e.target.value);
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Inscrição Estadual</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.customer?.ie || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('customer', 'ie', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={2}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Email</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.customer?.email || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('customer', 'email', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                    </Grid>
                                </Box>

                                <Divider />

                                {/* Seção Endereço */}
                                <Box>
                                    <Text fontWeight="bold" mb={2} color="blue.600">Endereço de Entrega</Text>
                                    <Grid templateColumns="repeat(4, 1fr)" gap={3}>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">CEP</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.shippingAddress?.zipCode || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('shippingAddress', 'zipCode', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={3}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Rua</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.shippingAddress?.street || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('shippingAddress', 'street', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Número</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.shippingAddress?.number || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('shippingAddress', 'number', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={3}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Complemento</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.shippingAddress?.complement || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('shippingAddress', 'complement', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={2}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Bairro</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.shippingAddress?.neighborhood || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('shippingAddress', 'neighborhood', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">Cidade</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.shippingAddress?.city || ''}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('shippingAddress', 'city', e.target.value)}
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <FormControl>
                                                <FormLabel fontSize="sm">UF</FormLabel>
                                                <Input
                                                    size="sm"
                                                    value={nfeIndividualCorrectionPayload.shippingAddress?.state || ''}
                                                    maxLength={2}
                                                    onChange={(e) => handleNfeIndividualCorrectionInputChange('shippingAddress', 'state', e.target.value.toUpperCase())}
                                                />
                                            </FormControl>
                                        </GridItem>
                                    </Grid>
                                </Box>
                            </VStack>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr={3} onClick={handleReenviarNfeIndividualComCorrecao} isLoading={loadingItemsNFML[nfeIndividualCorrectionTarget.id]}>
                            Salvar e Reenviar
                        </Button>
                        <Button variant="ghost" onClick={() => setIsModalNfeIndividualCorrectionOpen(false)}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <ChatMensagensML
                idOrigem={idPedidoMsg}
                vendaId={pedidoMsgAtivo?.id_taga}
                packId={pedidoMsgAtivo?.pack_id ? String(pedidoMsgAtivo.pack_id) : undefined}
                isOpen={isModalOpenMsg}
                onClose={closeModalMsg}
                nomeCompradorInicial={pedidoMsgAtivo?.comprador?.nickname}
                onMarcouLida={(packId) => {
                    setNaoLidasPorPackId(prev => ({
                        ...prev,
                        [packId]: { ...prev[packId], nao_lida: false, qtd: 0 },
                    }));
                }}
                onStatusLeituraChange={(packId, naoLida) => {
                    setNaoLidasPorPackId(prev => ({
                        ...prev,
                        [packId]: {
                            ...prev[packId],
                            nao_lida: naoLida,
                            qtd: naoLida ? (prev[packId]?.qtd || 0) : 0,
                        },
                    }));
                }}
            />


            <Modal isOpen={isModalOpenImprimirEtiquetasMassaML} onClose={handleCancelImprimirEtiquetasMassaML} size={{ base: "md", md: "xl", lg: "3xl", xl: "4xl" }}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader><Text fontSize={"18px"}>IMPRIMIR ETIQUETAS EM MASSA</Text></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormControl mb={4}>
                            <FormLabel htmlFor="tipoEtiquetaMassa">Tipo de Etiqueta</FormLabel>
                            <Select
                                id="tipoEtiquetaMassa"
                                value={tipoEtiquetaMassa}
                                onChange={handleTipoEtiquetaChange}
                                maxWidth="250px"  // Ajuste a largura conforme necessário
                                marginBottom={4}
                            >
                                <option value="pdf">PDF</option>
                                <option value="zpl2">ZPL</option>
                            </Select>
                        </FormControl>
                        <Box overflowX={"auto"}>
                            <Table variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th>Imagem</Th>
                                        <Th>Nome</Th>
                                        <Th>ID Venda</Th>
                                        <Th>Comprador</Th>
                                        <Th>Status</Th>
                                        <Th>Ações</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {vendasSelecionadasImprimirEtiquetaMassa && vendasSelecionadasImprimirEtiquetaMassa.map((venda) => (
                                        <Tr key={venda.id}>
                                            <Td m={0} py={1} textAlign={"center"}>
                                                <Flex flexDirection={"column"}>
                                                    {venda.produtos.map((produto) => (
                                                        <Box boxSize="30px">
                                                            <ProdutoImagem
                                                                produto={produto}
                                                                origem={venda.origem}
                                                                imagemAPI={produto.imageUrl}
                                                                width="30px"
                                                                height="30px"
                                                            />
                                                        </Box>
                                                    ))}
                                                </Flex>
                                            </Td>
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Flex flexDirection={"column"}>
                                                    {venda.produtos.map((produto) => (
                                                        <Text fontSize="8px" isTruncated maxW="100px">
                                                            {limitarCaracteres(produto.nome, 20)}
                                                        </Text>
                                                    ))}
                                                </Flex>
                                            </Td>
                                            <Td my={0} py={0} px={1} textAlign={"center"}><Flex flexDirection={"row"}><Text isTruncated maxW="180px" fontSize={"10px"} fontWeight={"bold"}>#{venda.id}</Text><Text ml={1} color={venda.conta == 1 ? "yellow.400" : Number(venda.conta) === 3 ? "green.400" : "blue.200"} isTruncated maxW="180px" fontSize={"10px"} fontWeight={"bold"}> Conta({venda.conta})</Text></Flex></Td>
                                            <Td my={0} py={0} px={1} textAlign={"center"}><Text fontSize={"8px"} fontWeight={"bold"}>{limitarCaracteres(venda?.comprador?.nickname, 20)}</Text></Td>
                                            <Td my={0} py={0} px={1} textAlign={"center"}>
                                                {/* Aqui o status depende do valor no estado */}
                                                {statusVendasEtiquetaMassa[venda.id] === 'PROCESSANDO' && <Spinner size="md" />}
                                                {statusVendasEtiquetaMassa[venda.id] === 'ERRO' && (
                                                    <Tooltip openDelay={500} isLazy label={mensagensErroEtiquetaMassa[venda.id] || "Erro desconhecido"}>
                                                        <Box bg="red.300" borderRadius={"full"}>
                                                            <Flex flexDirection={"row"} align={"center"} justify={"center"}>
                                                                <Text mr="1" fontSize={"10px"} fontWeight={"bold"}> ERRO</Text>
                                                                <FaInfoCircle size={10} />
                                                            </Flex>
                                                        </Box>
                                                    </Tooltip>
                                                )}
                                                {statusVendasEtiquetaMassa[venda.id] === 'CONCLUÍDO' && (
                                                    <Box bg="green.300" borderRadius={"full"}>
                                                        <Text fontSize={"10px"} fontWeight={"bold"}>SUCESSO</Text>
                                                    </Box>
                                                )}
                                                {(!statusVendasEtiquetaMassa[venda.id] || statusVendasEtiquetaMassa[venda.id] === 'NÃO PROCESSADO') && (
                                                    <Box bg="gray.300" borderRadius={"full"}>
                                                        <Text fontSize={"10px"} fontWeight={"bold"}>NÃO PROCESSADO</Text>
                                                    </Box>
                                                )}
                                            </Td>
                                            <Td my={0} py={0} textAlign={"center"}>
                                                <Tooltip openDelay={500} isLazy label={"Remover da Lista"}>
                                                    <IconButton
                                                        size={"xs"}
                                                        aria-label="Remover"
                                                        icon={<FaTrash size={10} />}
                                                        colorScheme="red"
                                                        onClick={() => removerVendaImprimirEtiquetaMasas(venda.id)}
                                                    />
                                                </Tooltip>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="green"
                            mr={3}
                            onClick={handleClickImprimirEtiquetasMassaML}
                            isLoading={isLoadingEtiquetaMassa}
                            loadingText="Processando..."
                            disabled={isLoadingEtiquetaMassa}
                        >
                            {isLoadingEtiquetaMassa ? (
                                <Spinner size="sm" />
                            ) : (
                                'Confirmar'
                            )}
                        </Button>
                        <Button variant="ghost" onClick={handleCancelImprimirEtiquetasMassaML}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <ModalNfeVendas
                pedidos={pedidos}
                handleCheckboxChange={handleCheckboxChange}
                setCheckboxesState={setCheckboxesState}
                limitarCaracteres={limitarCaracteres}
                isModalOpenEmitirNfesMassaML={isModalOpenEmitirNfesMassaML}
                setIsModalOpenEmitirNfesMassaML={setIsModalOpenEmitirNfesMassaML}
                vendasSelecionadasEmitirNfeMassa={vendasSelecionadasEmitirNfeMassa}
                setVendasSelecionadasEmitirNfeMassa={setVendasSelecionadasEmitirNfeMassa}
                setPedidos={setPedidos}
            />

            <Modal isOpen={isModalOpenConfirmNF} onClose={closeModalConfirmNF}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Confirmação</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="16" mb={4} >Tem certeza de que deseja emitir a nota fiscal da venda {idMktNF}?</Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleClickEmitirNFe}>
                            Confirmar
                        </Button>
                        <Button variant="ghost" onClick={handleCancelNF}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isModalOpenStatusVenda} onClose={closeModalStatusVenda}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Confirmação</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="16" mb={4} >Tem certeza de que deseja alterar o Status da venda <b>{idVendaSetStatus}</b> para <b>{valorStatusVenda}</b>?</Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleClickSetStatusVenda}>
                            Confirmar
                        </Button>
                        <Button variant="ghost" onClick={closeModalStatusVenda}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isModalOpenCotacao} onClose={closeModalCotacao} size={{ base: "md", md: "xl", lg: "3xl", xl: "4xl" }}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Lista para cotação</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex flexDirection={"column"}>
                            <Flex flexDirection={"row"} mb={2}>
                                <Text fontWeight={"bold"} fontSize={"16px"}> MORELATE </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} style={{ cursor: 'pointer' }} id={"copy_cotacao_morelate"} onClick={() => copiarCotacao(stringCotacaoMorelate, "morelate")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoMorelate}</Text>
                            <Divider mt={2} />
                            <Flex flexDirection={"row"} my={2} >
                                <Text my={2} fontWeight={"bold"} fontSize={"16px"}> VANNUCCI </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} mt={1} style={{ cursor: 'pointer' }} id={"copy_cotacao_vannucci"} onClick={() => copiarCotacao(stringCotacaoVannucci, "vannucci")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoVannucci}</Text>
                            <Divider mt={2} />
                            <Flex flexDirection={"row"} my={2} >
                                <Text my={2} fontWeight={"bold"} fontSize={"16px"}> ISAPA </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} mt={1} style={{ cursor: 'pointer' }} id={"copy_cotacao_isapa"} onClick={() => copiarCotacao(stringCotacaoIsapa, "isapa")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoIsapa}</Text>
                            <Divider mt={2} />
                            <Flex flexDirection={"row"} my={2} >
                                <Text my={2} fontWeight={"bold"} fontSize={"16px"}> BRCOMPANY </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} mt={1} style={{ cursor: 'pointer' }} id={"copy_cotacao_brcompany"} onClick={() => copiarCotacao(stringCotacaoBrcompany, "brcompany")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoBrcompany}</Text>
                            <Divider mt={2} />
                            <Flex flexDirection={"row"} my={2} >
                                <Text my={2} fontWeight={"bold"} fontSize={"16px"}> LNG </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} mt={1} style={{ cursor: 'pointer' }} id={"copy_cotacao_lng"} onClick={() => copiarCotacao(stringCotacaoLng, "lng")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoLng}</Text>
                            <Divider mt={2} />
                            <Flex flexDirection={"row"} my={2} >
                                <Text my={2} fontWeight={"bold"} fontSize={"16px"}> CBA </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} mt={1} style={{ cursor: 'pointer' }} id={"copy_cotacao_cba"} onClick={() => copiarCotacao(stringCotacaoCba, "cba")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoCba}</Text>
                            <Divider mt={2} />
                            <Flex flexDirection={"row"} my={2} >
                                <Text my={2} fontWeight={"bold"} fontSize={"16px"}> MSAM </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} mt={1} style={{ cursor: 'pointer' }} id={"copy_cotacao_msam"} onClick={() => copiarCotacao(stringCotacaoMsam, "msam")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoMsam}</Text>
                            <Divider mt={2} />
                            <Flex flexDirection={"row"} my={2} >
                                <Text my={2} fontWeight={"bold"} fontSize={"16px"}> BL PARTS </Text>
                                <Tooltip openDelay={500} isLazy label="Copiar">
                                    <Box color={"#595959"} ml={1} p={0} mt={1} style={{ cursor: 'pointer' }} id={"copy_cotacao_blparts"} onClick={() => copiarCotacao(stringCotacaoBlparts, "blparts")}>
                                        <FaCopy fontSize="1rem" />
                                    </Box>
                                </Tooltip>
                            </Flex>
                            <Text fontSize={"12px"}>{textCotacaoBlparts}</Text>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {
                pedidoSelecionado && (
                    <Modal isOpen={isModalOpenViewPedido} onClose={closeModalViewPedido} size={{ base: "md", md: "xl", lg: "5xl", xl: "6xl" }}>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Dados do Pedido</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                <Grid
                                    templateRows={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(3, 1fr)" }}
                                    templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)", lg: "repeat(2, 1fr)" }}
                                    gap={4}
                                >
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Cliente</Text>
                                            <Divider mb={1} />
                                            {
                                                pedidoSelecionado.notaEmitida == false &&
                                                (
                                                    <Text fontWeight={"bold"} color="red" fontSize={"14px"} >Atenção: O Mercado Livre só disponibiliza esses dados após o faturamento.</Text>
                                                )
                                            }
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Nome:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.cliente.nome}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Nickname:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.cliente.nickname}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> CPF/CNPJ:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.cliente.documento}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Telefone:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.cliente.telefone}</Text>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Endereço</Text>
                                            <Divider mb={1} />
                                            {
                                                pedidoSelecionado.notaEmitida == false &&
                                                (
                                                    <Text fontWeight={"bold"} color="red" fontSize={"14px"} >Atenção: O Mercado Livre só disponibiliza esses dados após o faturamento.</Text>
                                                )
                                            }
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Rua:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.endereco.rua}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Número:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.endereco.numero}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Bairro:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.endereco.bairro}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Complemento:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.endereco.complemento}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Cidade:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.endereco.cidade} ({pedidoSelecionado.dados_pedido.endereco.estado})</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> CEP:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.endereco.cep}</Text>
                                            </Flex>
                                            {
                                                pedidoSelecionado.dados_pedido.endereco.cep &&
                                                (
                                                    <Flex flexDirection={"row"} >
                                                        <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Maps:</Text>
                                                        <Link href={"https://www.google.com/maps/search/?api=1&query=" + pedidoSelecionado.dados_pedido.endereco.cep} isExternal>
                                                            <FaMap color="#01695E" fontSize="1.5rem" />
                                                        </Link>
                                                    </Flex>
                                                )
                                            }
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Pedido</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Origem:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Mercado Livre</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> ID origem:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.id}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> ID TAGA:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.id_taga}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Status Marketplace:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.status}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Status TAGA:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{getTextPedidoStatusTAGA(pedidoSelecionado)}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.data_hora}</Text>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Envio</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data limite de postagem:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado?.data_limite_envio}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data estimada de entrega:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado?.dados_pedido.envio?.previsao_entrega}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data em preparação:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado?.dados_pedido?.envio?.data_preparacao}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data de envio:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.envio.data_envio}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data de entrega:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.envio.data_entrega}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data de cancelamento:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.envio.data_cancelamento}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Frete:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.envio.frete?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Rastreio:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.envio.rastreio}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Etiqueta:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.envio.etiqueta}</Text>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Pagamento</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Forma de pagamento:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.pagamento.forma_pagamento}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Tipo de pagamento:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.pagamento.tipo_pagamento}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Parcelas:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.pagamento.parcelas}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Subtotal:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> {pedidoSelecionado.dados_pedido.pagamento.sub_total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Desconto:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoSelecionado.dados_pedido.pagamento.desconto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Total:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> {pedidoSelecionado.dados_pedido.pagamento.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Nota Fiscal</Text>
                                            <Divider mb={1} />
                                            {
                                                pedidoSelecionado.notaEmitida == false &&
                                                (
                                                    <Text fontWeight={"bold"} color="red" fontSize={"14px"} >Atenção: O Mercado Livre só disponibiliza esses dados após o faturamento.</Text>
                                                )
                                            }
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Chave:</Text>
                                                <Text style={{ whiteSpace: 'pre-wrap' }} fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{isMobile ? quebrarCaractere(pedidoSelecionado.dados_pedido.nfe.chave) : pedidoSelecionado.dados_pedido.nfe.chave}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Status:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> {pedidoSelecionado.dados_pedido.nfe.status}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> {pedidoSelecionado.dados_pedido.nfe.data}</Text>
                                            </Flex>
                                            {
                                                pedidoSelecionado.dados_pedido.nfe.danfe && (
                                                    <Flex flexDirection={"row"}>
                                                        <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Danfe:</Text>
                                                        <Link href={pedidoSelecionado.dados_pedido.nfe.danfe} isExternal>
                                                            <FaFileAlt fontSize="1.5rem" />
                                                        </Link>
                                                    </Flex>
                                                )
                                            }
                                        </Box>
                                    </GridItem>
                                </Grid>
                                <Box mt={6} bg='#f5bc93' borderRadius="lg">
                                    <Text align={"center"} fontWeight="bold" fontSize="18"> Produtos</Text>
                                    <Divider mb={1} />
                                    <TableContainer width={"100%"}>
                                        <Table size='sm'>
                                            <Thead width={"100%"}>
                                                <Tr>
                                                    <Th px={1} w={"15%"}><Text align='center'></Text></Th>
                                                    <Th px={1} w={"25%"}><Text align='start'>PRODUTO</Text></Th>
                                                    <Th px={1} w={"10%"}><Text align='center'>FORNECEDOR</Text></Th>
                                                    <Th px={1} w={"15%"}><Text align='center'>FISCAL</Text></Th>
                                                    <Th px={1} w={"12%"}><Text align='center'>ENVIO</Text></Th>
                                                    <Th px={1} w={"13%"}><Text align='center'>QUANTIDADE</Text></Th>
                                                    <Th px={1} w={"10%"}><Text align='center'>PREÇO</Text></Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {pedidoSelecionado.produtos.map((produto, index) => (
                                                    <Tr key={produto.id} width={"100%"}>
                                                        <Td>
                                                            <ProdutoImagem
                                                                produto={produto}
                                                                origem={pedidoSelecionado.origem}
                                                                imagemAPI={produto.imageUrl}
                                                            />
                                                        </Td>
                                                        <Td pl={0}>
                                                            <Flex fontSize={"12px"} flexDirection="column">
                                                                <Tooltip openDelay={500} isLazy label={produto.nome}>
                                                                    <Text fontSize={"12px"} fontWeight={"bold"}>{limitarCaracteres(produto.nome, 40)}</Text>
                                                                </Tooltip>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"} >SKU:</Text>
                                                                    <Text mr={1}>{produto.id}</Text><Link mt={"0.5"} href={window.location.origin + "/produtos?id=" + produto.id} isExternal><FaExternalLinkAlt size={12} color="blue" /></Link>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"} >Código Global:</Text>
                                                                    <Text fontWeight={"bold"}>{(produto.codigo != null && produto.codigo.length > 0) ? produto.codigo : "   - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"} >Código Fabricante:</Text>
                                                                    <Text>{(produto.codigo_fabricante != null && produto.codigo_fabricante.length > 0) ? produto.codigo_fabricante : "   - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"}>Código Fornecedor:</Text>
                                                                    <Text>{(produto.codigo_fornecedor != null && produto.codigo_fornecedor.length > 0) ? produto.codigo_fornecedor : "   - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"}>Fabricante:</Text>
                                                                    <Text>{(produto.fabricante != null && produto.fabricante.length > 0) ? produto.fabricante : "   - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"}>ID Anúncio:</Text>
                                                                    <Text>{produto.id_ml}</Text>
                                                                    <Box color={"#595959"} mx={0} p={0} style={{ cursor: 'pointer' }} id={"copy_anuncio_" + produto.id_ml} onClick={() => handleClickCopyAnuncio(produto.id_ml)}>
                                                                        <FaCopy fontSize="0.8rem" />
                                                                    </Box>
                                                                </Flex>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Tooltip openDelay={500} isLazy label={produto.fornecedor}>
                                                                <Flex justify="center" align="center">
                                                                    <Box w={{ base: "100%", md: "100%", lg: "50%" }}>
                                                                        <Flex justifyContent={"center"}>
                                                                            <Image
                                                                                loading="lazy" decoding="async"
                                                                                borderRadius="lg"
                                                                                src={getImagemFornecedor(produto.fornecedor)}
                                                                                alt={produto.fornecedor}
                                                                                h={{ base: "34px", lg: "40px" }}
                                                                                w="auto"
                                                                                maxW={{ base: "90px", lg: "110px" }}
                                                                                objectFit="contain"
                                                                            />
                                                                        </Flex>
                                                                    </Box>
                                                                </Flex>
                                                            </Tooltip>
                                                        </Td>
                                                        {index === 0 && (
                                                            <>
                                                                <Td>
                                                                    {
                                                                        (pedidoSelecionado.origem == "Mercado Livre" || pedidoSelecionado.origem == "Mercado Shops") && pedidoSelecionado.notaEmitida == true && (
                                                                            <>
                                                                                <Flex flexDirection="row" justify="center" align="center">
                                                                                    <Text fontWeight="bold"
                                                                                        fontSize="12px"
                                                                                        textTransform="uppercase"
                                                                                    >✅Nota Emitida</Text>
                                                                                </Flex>
                                                                                <Flex hidden flexDirection="row" justify="center" align="center">
                                                                                    <Box
                                                                                        id={"imprimir_etiqueta_pdf_" + pedidoSelecionado.id_taga}
                                                                                        bg="white"
                                                                                        p="1"
                                                                                        borderRadius="lg"
                                                                                        mt={2}
                                                                                        cursor="pointer"
                                                                                        transition="all 0.2s"
                                                                                        color="blue"
                                                                                        _hover={{
                                                                                            transform: "scale(1.05)",
                                                                                            bg: "blue",
                                                                                            color: "white",
                                                                                        }}
                                                                                    >
                                                                                        <Flex flexDirection={"row"}>
                                                                                            <FaDownload />
                                                                                            <Text
                                                                                                ml={1}
                                                                                                fontWeight="bold"
                                                                                                fontSize="12px"
                                                                                            >
                                                                                                XML
                                                                                            </Text>
                                                                                        </Flex>
                                                                                    </Box>
                                                                                </Flex>
                                                                            </>
                                                                        )
                                                                    }
                                                                    {
                                                                        (pedidoSelecionado.origem == "TAGA") && pedidoSelecionado.notaEmitida == true && (
                                                                            <>
                                                                                <Flex flexDirection="row" justify="center" align="center">
                                                                                    <Text fontWeight="bold"
                                                                                        fontSize="12px"
                                                                                        textTransform="uppercase"
                                                                                    >✅Nota Emitida</Text>
                                                                                </Flex>
                                                                                <Flex hidden flexDirection="row" justify="center" align="center">
                                                                                    <Box
                                                                                        id={"imprimir_etiqueta_pdf_" + pedidoSelecionado.id_taga}
                                                                                        bg="white"
                                                                                        p="1"
                                                                                        borderRadius="lg"
                                                                                        mt={2}
                                                                                        cursor="pointer"
                                                                                        transition="all 0.2s"
                                                                                        color="blue"
                                                                                        _hover={{
                                                                                            transform: "scale(1.05)",
                                                                                            bg: "blue",
                                                                                            color: "white",
                                                                                        }}
                                                                                    >
                                                                                        <Flex flexDirection={"row"}>
                                                                                            <FaDownload />
                                                                                            <Text
                                                                                                ml={1}
                                                                                                fontWeight="bold"
                                                                                                fontSize="12px"
                                                                                            >
                                                                                                XML
                                                                                            </Text>
                                                                                        </Flex>
                                                                                    </Box>
                                                                                </Flex>
                                                                            </>
                                                                        )
                                                                    }
                                                                    {
                                                                        (pedidoSelecionado.origem == "Mercado Livre" || pedidoSelecionado.origem == "Mercado Shops") && pedidoSelecionado.notaEmitida == false && (
                                                                            <>
                                                                                <Flex flexDirection="row" justify="center" align="center">
                                                                                    <Text fontWeight="bold"
                                                                                        fontSize="12px"
                                                                                        textTransform="uppercase"
                                                                                    >⚠️Nota Pendente</Text>
                                                                                </Flex>
                                                                                {

                                                                                    <Flex flexDirection="row" justify="center" align="center">
                                                                                        {
                                                                                            loadingItemsNFML[pedidoSelecionado.id_taga] ? (
                                                                                                <Box mt={2}>
                                                                                                    <Spinner size="md" />
                                                                                                </Box>
                                                                                            ) : (
                                                                                                (() => {
                                                                                                    const conferido = isPedidoConferidoParaDespacho(pedidoSelecionado);
                                                                                                    return (
                                                                                                        <Tooltip label="Venda nao conferida - conclua a conferencia antes de emitir NFe" isDisabled={conferido} placement="top" hasArrow>
                                                                                                            <Box
                                                                                                                id={"imprimir_etiqueta_pdf_" + pedidoSelecionado.id_taga}
                                                                                                                bg="yellow"
                                                                                                                p="1"
                                                                                                                borderRadius="lg"
                                                                                                                mt={2}
                                                                                                                cursor={conferido ? "pointer" : "not-allowed"}
                                                                                                                opacity={conferido ? 1 : 0.5}
                                                                                                                transition="all 0.2s"
                                                                                                                color="black"
                                                                                                                _hover={conferido ? {
                                                                                                                    transform: "scale(1.05)",
                                                                                                                    bg: "black",
                                                                                                                    color: "yellow",
                                                                                                                } : {}}
                                                                                                                onClick={() => openModalConfirmNF(pedidoSelecionado.id_taga, pedidoSelecionado.id)}
                                                                                                            >
                                                                                                                <Flex flexDirection={"row"}>
                                                                                                                    <FaFileInvoice />
                                                                                                                    <Text
                                                                                                                        ml={1}
                                                                                                                        fontWeight="bold"
                                                                                                                        fontSize="12px"
                                                                                                                    >
                                                                                                                        EMITIR
                                                                                                                    </Text>
                                                                                                                </Flex>
                                                                                                            </Box>
                                                                                                        </Tooltip>
                                                                                                    );
                                                                                                })()
                                                                                            )
                                                                                        }
                                                                                    </Flex>

                                                                                }
                                                                            </>
                                                                        )
                                                                    }
                                                                    {/* BLOCO PARA VENDAS MANUAIS (TAGA) */}
                                                                    {pedidoSelecionado.origem == "TAGA" && pedidoSelecionado.notaEmitida == false && (
                                                                        <>
                                                                            <Flex flexDirection="row" justify="center" align="center">
                                                                                <Text
                                                                                    fontWeight="bold"
                                                                                    fontSize="10px"
                                                                                    textTransform="uppercase"
                                                                                >
                                                                                    ⚠️Nota Pendente
                                                                                </Text>
                                                                            </Flex>

                                                                            <Flex flexDirection="row" justify="center" align="center">
                                                                                {(() => {
                                                                                    const conferido = isPedidoConferidoParaDespacho(pedidoSelecionado);
                                                                                    return (
                                                                                        <Tooltip label="Venda nao conferida - conclua a conferencia antes de emitir NFe" isDisabled={conferido} placement="top" hasArrow>
                                                                                            <Box
                                                                                                id={"emitir_nfe_taga_" + pedidoSelecionado.id_taga}
                                                                                                bg="yellow"
                                                                                                p="1"
                                                                                                borderRadius="lg"
                                                                                                mt={2}
                                                                                                cursor={conferido ? "pointer" : "not-allowed"}
                                                                                                opacity={conferido ? 1 : 0.5}
                                                                                                transition="all 0.2s"
                                                                                                color="black"
                                                                                                _hover={conferido ? {
                                                                                                    transform: "scale(1.05)",
                                                                                                    bg: "black",
                                                                                                    color: "yellow",
                                                                                                } : {}}
                                                                                                onClick={() => openModalConfirmNfeTaga(pedidoSelecionado.id_taga)}
                                                                                            >
                                                                                                <Flex flexDirection={"row"}>
                                                                                                    <FaFileInvoice />
                                                                                                    <Text
                                                                                                        ml={1}
                                                                                                        fontWeight="bold"
                                                                                                        fontSize="12px"
                                                                                                    >
                                                                                                        EMITIR
                                                                                                    </Text>
                                                                                                </Flex>
                                                                                            </Box>
                                                                                        </Tooltip>
                                                                                    );
                                                                                })()}
                                                                            </Flex>
                                                                        </>
                                                                    )}
                                                                </Td>
                                                                <Td pl={0}>
                                                                    <Flex px={0} mx={0} justify="center" align="center" flexDirection={"column"}>
                                                                        {
                                                                            pedidoSelecionado.envio && pedidoSelecionado.envio.modo_envio &&
                                                                            (
                                                                                <Text textDecoration="underline" color={pedidoSelecionado.envio.modo_envio == "Entrega a Combinar" ? "red.400" : "blue.600"} fontSize={"12px"} textTransform="uppercase" fontWeight={"bold"} px={0} mx={0} align='center'>{pedidoSelecionado.envio.modo_envio}</Text>
                                                                            )
                                                                        }
                                                                        {
                                                                            pedidoSelecionado.envio && pedidoSelecionado.envio.empresa &&
                                                                            (
                                                                                <Text fontSize={"8px"} fontWeight={"bold"} px={0} mx={0} align='center'>{pedidoSelecionado.envio.empresa}</Text>
                                                                            )
                                                                        }
                                                                        {
                                                                            pedidoSelecionado.pode_imprimir_etiqueta == true && (
                                                                                <>

                                                                                    {loadingItemsEtiqueta[pedidoSelecionado.id_taga] ? (
                                                                                        <Box mt={2}>
                                                                                            <Spinner size="md" />
                                                                                        </Box>
                                                                                    ) : (
                                                                                        (() => {
                                                                                            const conferido = isPedidoConferidoParaDespacho(pedidoSelecionado);
                                                                                            const tooltipMsg = "Venda nao conferida - conclua a conferencia antes de imprimir a etiqueta";
                                                                                            return (
                                                                                                <>
                                                                                                    <Tooltip label={tooltipMsg} isDisabled={conferido} placement="top" hasArrow>
                                                                                                        <Box
                                                                                                            id={"imprimir_etiqueta_pdf_" + pedidoSelecionado.id_taga}
                                                                                                            bg="white"
                                                                                                            p="1"
                                                                                                            borderRadius="lg"
                                                                                                            mt={2}
                                                                                                            cursor={conferido ? "pointer" : "not-allowed"}
                                                                                                            opacity={conferido ? 1 : 0.5}
                                                                                                            transition="all 0.2s"
                                                                                                            color="blue"
                                                                                                            _hover={conferido ? {
                                                                                                                transform: "scale(1.05)",
                                                                                                                bg: "blue",
                                                                                                                color: "white",
                                                                                                            } : {}}
                                                                                                            onClick={() => handleClickImprimirEtiqueta(pedidoSelecionado.id_taga, "pdf", pedidoSelecionado.id)}
                                                                                                        >
                                                                                                            <Flex flexDirection={"row"}>
                                                                                                                <FaDownload />
                                                                                                                <Text
                                                                                                                    ml={1}
                                                                                                                    fontWeight="bold"
                                                                                                                    fontSize="12px"
                                                                                                                >
                                                                                                                    ETIQUETA PDF
                                                                                                                </Text>
                                                                                                            </Flex>
                                                                                                        </Box>
                                                                                                    </Tooltip>

                                                                                                    <Tooltip label={tooltipMsg} isDisabled={conferido} placement="top" hasArrow>
                                                                                                        <Box
                                                                                                            id={"imprimir_etiqueta_zpl2_" + pedidoSelecionado.id_taga}
                                                                                                            bg="white"
                                                                                                            p="1"
                                                                                                            borderRadius="lg"
                                                                                                            mt={2}
                                                                                                            cursor={conferido ? "pointer" : "not-allowed"}
                                                                                                            opacity={conferido ? 1 : 0.5}
                                                                                                            transition="all 0.2s"
                                                                                                            color="blue"
                                                                                                            _hover={conferido ? {
                                                                                                                transform: "scale(1.05)",
                                                                                                                bg: "blue",
                                                                                                                color: "white",
                                                                                                            } : {}}
                                                                                                            onClick={() => handleClickImprimirEtiqueta(pedidoSelecionado.id_taga, "zpl2", pedidoSelecionado.id)}
                                                                                                        >
                                                                                                            <Flex flexDirection={"row"}>
                                                                                                                <FaDownload />
                                                                                                                <Text
                                                                                                                    ml={1}
                                                                                                                    fontWeight="bold"
                                                                                                                    fontSize="12px"
                                                                                                                >
                                                                                                                    ETIQUETA ZPL
                                                                                                                </Text>
                                                                                                            </Flex>
                                                                                                        </Box>
                                                                                                    </Tooltip>
                                                                                                </>
                                                                                            );
                                                                                        })()
                                                                                    )}

                                                                                </>
                                                                            )
                                                                        }
                                                                    </Flex>
                                                                </Td>
                                                            </>
                                                        )}
                                                        {index > 0 && (
                                                            <>
                                                                <Td pl={0}></Td>
                                                                <Td pl={0}></Td>
                                                            </>
                                                        )}
                                                        <Td pl={0}>
                                                            <Flex flexDirection={"column"} justify="center" align="center">
                                                                {
                                                                    produto.quantidade_taga > 0 && (
                                                                        <Flex flexDirection={"column"} mb={2}>
                                                                            <Text align='center' color="red" fontWeight={"bold"}>{"QTD TAGA (" + produto.quantidade_taga + ")"}</Text>
                                                                            {
                                                                                produto?.local_estoque?.length > 0 && (
                                                                                    <>
                                                                                        <Text fontSize={"10px"} mb={0} pb={0} align='center' color="black" fontWeight={"bold"}>{"Localização Estoque: "}</Text>
                                                                                        <Text fontSize={"10px"} mt={0} pt={0} align='center' color="red" fontWeight={"bold"}>{produto?.local_estoque}</Text>
                                                                                    </>
                                                                                )
                                                                            }
                                                                        </Flex>
                                                                    )
                                                                }
                                                                <Text fontWeight={"bold"} color="blue" align='center'>{produto.quantidade}</Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td pl={0}>
                                                            <Flex flexDirection="column" justify="center" align="center" gap={0}>
                                                                {produto.promocao_lista_id && (
                                                                    <>
                                                                        <Badge colorScheme="green" fontSize="8px" mb={0.5} display="flex" alignItems="center" gap="2px" maxW="120px" cursor="pointer" onClick={(e) => { e.stopPropagation(); window.open(`/promocoes/${produto.promocao_lista_id}`, '_blank'); }} _hover={{ opacity: 0.8 }}><MdLocalOffer size={10} style={{ flexShrink: 0 }} /> <Text as="span" isTruncated fontSize="8px">{produto.promocao_lista_titulo || "PROMO"}</Text></Badge>
                                                                        <Text fontSize="10px" color="gray.400" textDecoration="line-through" lineHeight="1">
                                                                            R$ {parseFloat(produto.preco_original).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                                        </Text>
                                                                    </>
                                                                )}
                                                                {!produto.promocao_lista_id && produto.promocao_taga_estoque && (
                                                                    <Badge colorScheme="yellow" fontSize="8px" mb={0.5} display="flex" alignItems="center" gap="2px" maxW="140px">
                                                                        <MdLocalOffer size={10} style={{ flexShrink: 0 }} />
                                                                        <Text as="span" isTruncated fontSize="8px">PROMO ESTOQUE TAGA</Text>
                                                                    </Badge>
                                                                )}
                                                                <Text fontWeight={"bold"} align='center' color={produto.promocao_lista_id ? "green.600" : (produto.promocao_taga_estoque ? "yellow.700" : "black")}>
                                                                    R$ {produto.preco?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                            <Tfoot>
                                                {openPedidosFooter[pedidoSelecionado.id + "_modal"] && (
                                                    <>
                                                        <Tr bg="#edae80">
                                                            <Th></Th><Th></Th><Th></Th><Th></Th><Th></Th>
                                                            <Th color="white" py={0} my={0} fontSize={{ base: "12px" }}>
                                                                <Text textAlign="end">Total Itens</Text>
                                                            </Th>
                                                            <Th color="white" py={0} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                                <Text textAlign="center">{pedidoSelecionado.total_itens}</Text>
                                                            </Th>
                                                        </Tr>

                                                        <Tr bg="#edae80">
                                                            <Th></Th><Th></Th><Th></Th><Th></Th><Th></Th>
                                                            <Th color="white" py={0} my={0} fontSize={{ base: "12px" }}>
                                                                <Text textAlign="end">Subtotal</Text>
                                                            </Th>
                                                            <Th color="white" py={0} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                                {pedidoSelecionado.dados_pedido.pagamento.sub_total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                            </Th>
                                                        </Tr>

                                                        <Tr bg="#edae80">
                                                            <Th></Th><Th></Th><Th></Th><Th></Th><Th></Th>
                                                            <Th color="white" py={0} my={0} fontSize={{ base: "12px" }}>
                                                                <Text textAlign="end">Desconto</Text>
                                                            </Th>
                                                            <Th color="white" py={0} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                                {pedidoSelecionado.dados_pedido.pagamento.desconto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                            </Th>
                                                        </Tr>
                                                    </>
                                                )}

                                                <Tr
                                                    bg="#edae80"
                                                    py={2}
                                                    onClick={() => toggleAccordionPedidosFooter(pedidoSelecionado.id + "_modal")}
                                                    style={{ cursor: "pointer", position: "relative" }}
                                                >
                                                    <Box
                                                        position="absolute"
                                                        top="50%"
                                                        left="50%"
                                                        transform="translate(-50%, -50%)"
                                                        pointerEvents="none"
                                                        color="white"
                                                    >
                                                        {openPedidosFooter[pedidoSelecionado.id + "_modal"] ? (
                                                            <ChevronUpIcon boxSize={5} />
                                                        ) : (
                                                            <ChevronDownIcon boxSize={5} />
                                                        )}
                                                    </Box>
                                                    <Th py={1}></Th>
                                                    <Th py={1}></Th>
                                                    <Th py={1}></Th>
                                                    <Th py={1}></Th>

                                                    <Th color="white" py={1} my={0} fontSize={{ base: "12px" }}>
                                                        <Text textAlign="end">Total</Text>
                                                    </Th>

                                                    <Th color="white" py={1} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                        <Text>{pedidoSelecionado.dados_pedido.pagamento.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                                    </Th>
                                                </Tr>
                                            </Tfoot>


                                        </Table>
                                    </TableContainer>
                                </Box>
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                )

            }


            {
                pedidoManualSelecionado && (
                    <Modal isOpen={isModalOpenViewPedidoTaga} onClose={closeModalViewPedidoTaga} size={{ base: "md", md: "xl", lg: "5xl", xl: "6xl" }}>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Dados do Pedido</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                <Grid
                                    templateRows={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(3, 1fr)" }}
                                    templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)", lg: "repeat(2, 1fr)" }}
                                    gap={4}
                                >
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Cliente</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Nome:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.cliente.nome}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> CPF/CNPJ:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.cliente.documento}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Telefone:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.cliente.telefone}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Email:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.cliente.email}</Text>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Endereço</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Rua:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.endereco.endereco}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Número:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.endereco.numero}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Bairro:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.endereco.bairro}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Complemento:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.endereco.complemento}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Cidade:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.endereco.cidade} - ({pedidoManualSelecionado.dados_pedido.endereco.uf})</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> CEP:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.endereco.cep}</Text>
                                            </Flex>
                                            {
                                                pedidoManualSelecionado.dados_pedido.endereco.cep &&
                                                (
                                                    <Flex flexDirection={"row"} >
                                                        <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Maps:</Text>
                                                        <Link href={"https://www.google.com/maps/search/?api=1&query=" + pedidoManualSelecionado.dados_pedido.endereco.cep} isExternal>
                                                            <FaMap color="#01695E" fontSize="1.5rem" />
                                                        </Link>
                                                    </Flex>
                                                )
                                            }
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Pedido</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Origem:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> TAGA ({pedidoManualSelecionado.origem == "ECOMMERCE" ? "ECOMMERCE" : "Venda Manual"})</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> ID TAGA:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.id_taga}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Status TAGA:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{getTextPedidoStatusTAGA(pedidoManualSelecionado)}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Status Envio:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.status}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Data:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.data_hora}</Text>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Envio</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Empresa:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado?.dados_pedido.envio?.empresa}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Modo Envio:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado?.dados_pedido.envio?.modo_envio}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Valor Frete:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado?.dados_pedido.envio?.valor_frete?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Prazo Envio:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado?.dados_pedido?.envio?.prazo}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Código Rastreio:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.envio.codigo_rastreio}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Link Rastreio:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.envio.link_rastreio}</Text>
                                                </Flex>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Observações:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.envio.observacao}</Text>
                                                </Flex>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Pagamento</Text>
                                            <Divider mb={1} />
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Forma de pagamento:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.pagamento.forma_pagamento}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Subtotal:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.pagamento.sub_total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Desconto:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.pagamento.desconto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Valor Total:</Text>
                                                <Text fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}>{pedidoManualSelecionado.dados_pedido.pagamento.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                            </Flex>
                                            <Flex flexDirection={"row"}>
                                                <Text mr={2} fontWeight="bold" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> Observações:</Text>
                                                <Flex flexWrap="wrap">
                                                    <Text wordBreak="break-word" fontSize={{ base: "12px", md: "14px", lg: "16px" }} mb={2}> {pedidoManualSelecionado.dados_pedido.pagamento.observacao}</Text>
                                                </Flex>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                    <GridItem bg='#f5bc93' borderRadius="lg">
                                        <Box m={2}>
                                            <Text align={"center"} fontWeight="bold" fontSize="18"> Nota Fiscal</Text>
                                            <Divider mb={1} />
                                        </Box>
                                    </GridItem>
                                </Grid>
                                <Box mt={6} bg='#f5bc93' borderRadius="lg">
                                    <Text align={"center"} fontWeight="bold" fontSize="18"> Produtos</Text>
                                    <Divider mb={1} />
                                    <TableContainer width={"100%"}>
                                        <Table size='sm'>
                                            <Thead width={"100%"}>
                                                <Tr>
                                                    <Th px={1} w={"15%"}><Text align='center'></Text></Th>
                                                    <Th px={1} w={"25%"}><Text align='start'>PRODUTO</Text></Th>
                                                    <Th px={1} w={"10%"}><Text align='center'>FORNECEDOR</Text></Th>
                                                    <Th px={1} w={"13%"}><Text align='center'>QUANTIDADE</Text></Th>
                                                    <Th px={1} w={"10%"}><Text align='center'>PREÇO</Text></Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {pedidoManualSelecionado.produtos.map((produto) => (
                                                    <Tr key={produto.id} width={"100%"}>
                                                        <Td>
                                                            <ProdutoImagem
                                                                produto={produto}
                                                                origem={pedidoManualSelecionado.origem}
                                                                imagemAPI={produto.imageUrl}
                                                            />
                                                        </Td>
                                                        <Td pl={0}>
                                                            <Flex fontSize={"12px"} flexDirection="column">
                                                                <Tooltip openDelay={500} isLazy label={produto.nome}>
                                                                    <Text fontSize={"12px"} fontWeight={"bold"}>{limitarCaracteres(produto.nome, 40)}</Text>
                                                                </Tooltip>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"} >SKU:</Text>
                                                                    <Text mr={1}>{produto.id}</Text><Link mt={"0.5"} href={window.location.origin + "/produtos?id=" + produto.id} isExternal><FaExternalLinkAlt size={12} color="blue" /></Link>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"} >Código Global:</Text>
                                                                    <Text fontWeight={"bold"}>{(produto.codigo != null && produto.codigo.length > 0) ? produto.codigo : "   - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"} >Código Fabricante:</Text>
                                                                    <Text>{(produto.codigo_fabricante != null && produto.codigo_fabricante.length > 0) ? produto.codigo_fabricante : "   - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"}>Código Fornecedor:</Text>
                                                                    <Text>{(produto.codigo_fornecedor != null && produto.codigo_fornecedor.length > 0) ? produto.codigo_fornecedor : "   - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection={"row"}>
                                                                    <Text mr={2} color={"#525F65"} fontWeight={"bold"}>Fabricante:</Text>
                                                                    <Text>{(produto.fabricante != null && produto.fabricante.length > 0) ? produto.fabricante : "   - "}</Text>
                                                                </Flex>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Tooltip openDelay={500} isLazy label={produto.fornecedor}>
                                                                <Flex justify="center" align="center">
                                                                    <Box w={{ base: "100%", md: "100%", lg: "50%" }}>
                                                                        <Flex justifyContent={"center"}>
                                                                            <Image
                                                                                loading="lazy" decoding="async"
                                                                                borderRadius="lg"
                                                                                src={getImagemFornecedor(produto.fornecedor)}
                                                                                alt={produto.fornecedor}
                                                                                h={{ base: "34px", lg: "40px" }}
                                                                                w="auto"
                                                                                maxW={{ base: "90px", lg: "110px" }}
                                                                                objectFit="contain"
                                                                            />
                                                                        </Flex>
                                                                    </Box>
                                                                </Flex>
                                                            </Tooltip>
                                                        </Td>
                                                        <Td pl={0}>
                                                            <Flex flexDirection={"column"} justify="center" align="center">
                                                                {
                                                                    produto.quantidade_taga > 0 && (
                                                                        <Flex flexDirection={"column"} mb={2}>
                                                                            <Text align='center' color="red" fontWeight={"bold"}>{"QTD TAGA (" + produto.quantidade_taga + ")"}</Text>
                                                                            {
                                                                                produto?.local_estoque?.length > 0 && (
                                                                                    <>
                                                                                        <Text fontSize={"10px"} mb={0} pb={0} align='center' color="black" fontWeight={"bold"}>{"Localização Estoque: "}</Text>
                                                                                        <Text fontSize={"10px"} mt={0} pt={0} align='center' color="red" fontWeight={"bold"}>{produto?.local_estoque}</Text>
                                                                                    </>
                                                                                )
                                                                            }
                                                                        </Flex>
                                                                    )
                                                                }
                                                                <Text fontWeight={"bold"} color="blue" align='center'>{produto.quantidade}</Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td pl={0}>
                                                            <Flex flexDirection="column" justify="center" align="center" gap={0}>
                                                                {produto.promocao_lista_id && (
                                                                    <>
                                                                        <Badge colorScheme="green" fontSize="8px" mb={0.5} display="flex" alignItems="center" gap="2px" maxW="120px" cursor="pointer" onClick={(e) => { e.stopPropagation(); window.open(`/promocoes/${produto.promocao_lista_id}`, '_blank'); }} _hover={{ opacity: 0.8 }}><MdLocalOffer size={10} style={{ flexShrink: 0 }} /> <Text as="span" isTruncated fontSize="8px">{produto.promocao_lista_titulo || "PROMO"}</Text></Badge>
                                                                        <Text fontSize="10px" color="gray.400" textDecoration="line-through" lineHeight="1">
                                                                            R$ {parseFloat(produto.preco_original).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                                        </Text>
                                                                    </>
                                                                )}
                                                                {!produto.promocao_lista_id && produto.promocao_taga_estoque && (
                                                                    <Badge colorScheme="yellow" fontSize="8px" mb={0.5} display="flex" alignItems="center" gap="2px" maxW="140px">
                                                                        <MdLocalOffer size={10} style={{ flexShrink: 0 }} />
                                                                        <Text as="span" isTruncated fontSize="8px">PROMO ESTOQUE TAGA</Text>
                                                                    </Badge>
                                                                )}
                                                                <Text fontWeight={"bold"} align='center' color={produto.promocao_lista_id ? "green.600" : (produto.promocao_taga_estoque ? "yellow.700" : "black")}>
                                                                    {produto.preco?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                            <Tfoot>
                                                {openPedidosFooter[pedidoManualSelecionado.id + "_modal"] && (
                                                    <>
                                                        <Tr bg="#edae80">
                                                            <Th></Th><Th></Th><Th></Th>
                                                            <Th color="white" py={0} my={0} fontSize={{ base: "12px" }}>
                                                                <Text textAlign="end">Total Itens</Text>
                                                            </Th>
                                                            <Th color="white" py={0} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                                <Text textAlign="center">{pedidoManualSelecionado.total_itens}</Text>
                                                            </Th>
                                                        </Tr>

                                                        <Tr bg="#edae80">
                                                            <Th></Th><Th></Th><Th></Th>
                                                            <Th color="white" py={0} my={0} fontSize={{ base: "12px" }}>
                                                                <Text textAlign="end">Subtotal</Text>
                                                            </Th>
                                                            <Th color="white" py={0} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                                {pedidoManualSelecionado.dados_pedido.pagamento.sub_total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                            </Th>
                                                        </Tr>

                                                        <Tr bg="#edae80">
                                                            <Th></Th><Th></Th><Th></Th>
                                                            <Th color="white" py={0} my={0} fontSize={{ base: "12px" }}>
                                                                <Text textAlign="end">Desconto</Text>
                                                            </Th>
                                                            <Th color="white" py={0} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                                {pedidoManualSelecionado.dados_pedido.pagamento.desconto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                            </Th>
                                                        </Tr>
                                                    </>
                                                )}

                                                <Tr
                                                    bg="#edae80"
                                                    py={2}
                                                    onClick={() => toggleAccordionPedidosFooter(pedidoManualSelecionado.id + "_modal")}
                                                    style={{ cursor: "pointer", position: "relative" }}
                                                >
                                                    <Box
                                                        position="absolute"
                                                        top="50%"
                                                        left="50%"
                                                        transform="translate(-50%, -50%)"
                                                        pointerEvents="none"
                                                        color="white"
                                                    >
                                                        {openPedidosFooter[pedidoManualSelecionado.id + "_modal"] ? (
                                                            <ChevronUpIcon boxSize={5} />
                                                        ) : (
                                                            <ChevronDownIcon boxSize={5} />
                                                        )}
                                                    </Box>
                                                    <Th py={1}></Th>
                                                    <Th py={1}></Th>

                                                    <Th color="white" py={1} my={0} fontSize={{ base: "12px" }}>
                                                        <Text textAlign="end">Total</Text>
                                                    </Th>

                                                    <Th color="white" py={1} my={0} isNumeric fontSize={{ base: "12px" }}>
                                                        <Text>{pedidoManualSelecionado.dados_pedido.pagamento.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Text>
                                                    </Th>
                                                </Tr>
                                            </Tfoot>


                                        </Table>
                                    </TableContainer>
                                </Box>
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                )

            }


            <Modal isOpen={isTicketModalOpen} onClose={closeTicketModal} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Criar Ticket para Venda</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text mb={4}>
                            Criando ticket para a Venda: <Text as="b">#{selectedVendaForTicket?.id}</Text>
                        </Text>

                        <FormControl isRequired>
                            <FormLabel>Selecione o Problema</FormLabel>
                            <Select
                                placeholder="Escolha um template de problema"
                                value={ticketTemplate}
                                onChange={(e) => setTicketTemplate(e.target.value)}
                            >
                                <option value="Problema no envio">Problema no envio</option>
                                <option value="Falha de precificação">Falha de precificação</option>
                                <option value="Falha na conferência">Falha na conferência</option>
                                <option value="Solicitação de garantia">Solicitação de garantia</option>
                                <option value="Solicitação de envio de unidades faltantes">Solicitação de envio de unidades faltantes</option>
                                <option value="Devolução com troca">Devolução com troca</option>
                            </Select>
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={closeTicketModal} isDisabled={isCreatingTicket}>
                            Cancelar
                        </Button>
                        <Button
                            colorScheme="orange"
                            isLoading={isCreatingTicket}
                            loadingText="Criando..."
                            onClick={handleConfirmCreateTicket}
                            disabled={!ticketTemplate || isCreatingTicket}
                        >
                            Confirmar e Criar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* --- MODAL RESULTADO / EDIÇÃO NFE TAGA --- */}
            <Modal isOpen={isModalNfeTagaOpen} onClose={handleCloseModalNfeTaga} size="xl" scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {isEditingNfePayload ? "Ajustar Dados da Nota" : "Emissão de NF-e (TAGA)"}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        {loadingNfeTaga ? (
                            <Flex direction="column" align="center" justify="center" py={10}>
                                <Spinner size="xl" color="orange.500" thickness="4px" />
                                <Text mt={4} fontWeight="bold">Processando...</Text>
                            </Flex>
                        ) : (
                            <>
                                {isEditingNfePayload && editablePayload ? (
                                    <Stack spacing={4}>
                                        <Alert status="warning" fontSize="sm" borderRadius="md">
                                            <AlertIcon />
                                            <Box flex="1">
                                                <AlertTitle>Modo de Correção Manual</AlertTitle>
                                                Edite os campos com cuidado.
                                            </Box>
                                        </Alert>

                                        <Accordion allowToggle defaultIndex={[0]} allowMultiple>

                                            {/* 1. DADOS DO CLIENTE */}
                                            <AccordionItem border="1px solid #e2e8f0" borderRadius="md" mb={2}>
                                                <h2>
                                                    <AccordionButton _expanded={{ bg: 'orange.100', color: 'orange.800' }}>
                                                        <Box flex="1" textAlign="left" fontWeight="bold">
                                                            1. Dados do Cliente
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    <Stack spacing={3}>
                                                        <FormControl>
                                                            <FormLabel fontSize="sm">Nome / Razão Social</FormLabel>
                                                            <Input size="sm" value={editablePayload.customer.name} onChange={(e) => handlePayloadChange('customer', 'name', e.target.value)} />
                                                        </FormControl>
                                                        <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">CPF/CNPJ</FormLabel>
                                                                <Input size="sm" value={editablePayload.customer.cpf || editablePayload.customer.cnpj || ''}
                                                                    onChange={(e) => {
                                                                        const field = editablePayload.customer.cnpj ? 'cnpj' : 'cpf';
                                                                        handlePayloadChange('customer', field, e.target.value);
                                                                    }}
                                                                />
                                                            </FormControl>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">Email</FormLabel>
                                                                <Input size="sm" value={editablePayload.customer.email} onChange={(e) => handlePayloadChange('customer', 'email', e.target.value)} />
                                                            </FormControl>
                                                            {editablePayload.customer.cnpj !== undefined && (
                                                                <FormControl>
                                                                    <FormLabel fontSize="sm">Inscrição Estadual</FormLabel>
                                                                    <Input size="sm" value={editablePayload.customer.ie || ''} onChange={(e) => handlePayloadChange('customer', 'ie', e.target.value)} />
                                                                </FormControl>
                                                            )}
                                                        </Grid>
                                                    </Stack>
                                                </AccordionPanel>
                                            </AccordionItem>

                                            {/* 2. ENDEREÇO */}
                                            <AccordionItem border="1px solid #e2e8f0" borderRadius="md" mb={2}>
                                                <h2>
                                                    <AccordionButton _expanded={{ bg: 'orange.100', color: 'orange.800' }}>
                                                        <Box flex="1" textAlign="left" fontWeight="bold">
                                                            2. Endereço de Entrega
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    <Grid templateColumns="repeat(6, 1fr)" gap={3}>
                                                        <GridItem colSpan={2}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">CEP</FormLabel>
                                                                <Input size="sm" value={editablePayload.shippingAddress.zipCode} onChange={(e) => handlePayloadChange('shippingAddress', 'zipCode', e.target.value)} />
                                                            </FormControl>
                                                        </GridItem>
                                                        <GridItem colSpan={4}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">Rua</FormLabel>
                                                                <Input size="sm" value={editablePayload.shippingAddress.street} onChange={(e) => handlePayloadChange('shippingAddress', 'street', e.target.value)} />
                                                            </FormControl>
                                                        </GridItem>
                                                        <GridItem colSpan={2}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">Número</FormLabel>
                                                                <Input size="sm" value={editablePayload.shippingAddress.number} onChange={(e) => handlePayloadChange('shippingAddress', 'number', e.target.value)} />
                                                            </FormControl>
                                                        </GridItem>
                                                        <GridItem colSpan={2}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">Comp.</FormLabel>
                                                                <Input size="sm" value={editablePayload.shippingAddress.complement || ''} onChange={(e) => handlePayloadChange('shippingAddress', 'complement', e.target.value)} />
                                                            </FormControl>
                                                        </GridItem>
                                                        <GridItem colSpan={2}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">Bairro</FormLabel>
                                                                <Input size="sm" value={editablePayload.shippingAddress.neighborhood} onChange={(e) => handlePayloadChange('shippingAddress', 'neighborhood', e.target.value)} />
                                                            </FormControl>
                                                        </GridItem>
                                                        <GridItem colSpan={4}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">Cidade</FormLabel>
                                                                <Input size="sm" value={editablePayload.shippingAddress.city} onChange={(e) => handlePayloadChange('shippingAddress', 'city', e.target.value)} />
                                                            </FormControl>
                                                        </GridItem>
                                                        <GridItem colSpan={2}>
                                                            <FormControl>
                                                                <FormLabel fontSize="sm">UF</FormLabel>
                                                                <Input size="sm" maxLength={2} value={editablePayload.shippingAddress.state} onChange={(e) => handlePayloadChange('shippingAddress', 'state', e.target.value.toUpperCase())} />
                                                            </FormControl>
                                                        </GridItem>
                                                    </Grid>
                                                </AccordionPanel>
                                            </AccordionItem>

                                            {/* 3. PRODUTOS / ITENS */}
                                            <AccordionItem border="1px solid #e2e8f0" borderRadius="md" mb={2}>
                                                <h2>
                                                    <AccordionButton _expanded={{ bg: 'orange.100', color: 'orange.800' }}>
                                                        <Box flex="1" textAlign="left" fontWeight="bold">
                                                            3. Produtos ({editablePayload.items.length})
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    {editablePayload.items.map((item, idx) => (
                                                        <Box key={idx} mb={4} p={3} bg="gray.50" borderRadius="md" border="1px solid #eee">
                                                            <Text fontSize="xs" fontWeight="bold" mb={2} color="gray.500">Item {idx + 1}</Text>
                                                            <Stack spacing={2}>
                                                                <FormControl>
                                                                    <FormLabel fontSize="xs">Nome do Produto</FormLabel>
                                                                    <Input size="xs" value={item.name} onChange={(e) => handleItemChange(idx, 'name', e.target.value)} />
                                                                </FormControl>
                                                                <Grid templateColumns="repeat(4, 1fr)" gap={2}>
                                                                    <GridItem colSpan={1}>
                                                                        <FormControl>
                                                                            <FormLabel fontSize="xs">SKU</FormLabel>
                                                                            <Input size="xs" value={item.sku} onChange={(e) => handleItemChange(idx, 'sku', e.target.value)} />
                                                                        </FormControl>
                                                                    </GridItem>
                                                                    <GridItem colSpan={1}>
                                                                        <FormControl>
                                                                            <FormLabel fontSize="xs">Qtd</FormLabel>
                                                                            <Input size="xs" type="number" value={item.quantity} onChange={(e) => handleItemChange(idx, 'quantity', parseFloat(e.target.value))} />
                                                                        </FormControl>
                                                                    </GridItem>
                                                                    <GridItem colSpan={1}>
                                                                        <FormControl>
                                                                            <FormLabel fontSize="xs">Preço Unit.</FormLabel>
                                                                            <Input size="xs" type="number" value={item.price} onChange={(e) => handleItemChange(idx, 'price', parseFloat(e.target.value))} />
                                                                        </FormControl>
                                                                    </GridItem>
                                                                    <GridItem colSpan={1}>
                                                                        <FormControl>
                                                                            <FormLabel fontSize="xs">Total Item</FormLabel>
                                                                            <Input size="xs" type="number" value={item.total} onChange={(e) => handleItemChange(idx, 'total', parseFloat(e.target.value))} />
                                                                        </FormControl>
                                                                    </GridItem>
                                                                </Grid>
                                                            </Stack>
                                                        </Box>
                                                    ))}
                                                </AccordionPanel>
                                            </AccordionItem>

                                            {/* 4. TOTAIS E PAGAMENTO */}
                                            <AccordionItem border="1px solid #e2e8f0" borderRadius="md" mb={2}>
                                                <h2>
                                                    <AccordionButton _expanded={{ bg: 'orange.100', color: 'orange.800' }}>
                                                        <Box flex="1" textAlign="left" fontWeight="bold">
                                                            4. Totais e Pagamento
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>
                                                    <Text fontWeight="bold" fontSize="sm" mb={2}>Totais</Text>
                                                    <Grid templateColumns="repeat(2, 1fr)" gap={3} mb={4}>
                                                        <FormControl>
                                                            <FormLabel fontSize="sm">Subtotal</FormLabel>
                                                            <Input size="sm" type="number" value={editablePayload.totals.subtotal} onChange={(e) => handlePayloadChange('totals', 'subtotal', parseFloat(e.target.value))} />
                                                        </FormControl>
                                                        <FormControl>
                                                            <FormLabel fontSize="sm">Frete</FormLabel>
                                                            <Input size="sm" type="number" value={editablePayload.totals.shippingCost} onChange={(e) => handlePayloadChange('totals', 'shippingCost', parseFloat(e.target.value))} />
                                                        </FormControl>
                                                        <FormControl>
                                                            <FormLabel fontSize="sm">Desconto</FormLabel>
                                                            <Input size="sm" type="number" value={editablePayload.totals.discount} onChange={(e) => handlePayloadChange('totals', 'discount', parseFloat(e.target.value))} />
                                                        </FormControl>
                                                        <FormControl>
                                                            <FormLabel fontSize="sm" color="green.600" fontWeight="bold">TOTAL FINAL</FormLabel>
                                                            <Input size="sm" type="number" fontWeight="bold" value={editablePayload.totals.total} onChange={(e) => handlePayloadChange('totals', 'total', parseFloat(e.target.value))} />
                                                        </FormControl>
                                                    </Grid>

                                                    <Divider mb={3} />
                                                    <Text fontWeight="bold" fontSize="sm" mb={2}>Pagamento</Text>
                                                    <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                                        <FormControl>
                                                            <FormLabel fontSize="sm">Método</FormLabel>
                                                            <Select size="sm" value={editablePayload.payment.method} onChange={(e) => handlePayloadChange('payment', 'method', e.target.value)}>
                                                                <option value="CREDIT_CARD">Cartão de Crédito</option>
                                                                <option value="DEBIT_CARD">Cartão de Débito</option>
                                                                <option value="PIX">PIX</option>
                                                                <option value="BOLETO">Boleto</option>
                                                                <option value="OTHERS">Outros</option>
                                                            </Select>
                                                        </FormControl>
                                                        <FormControl>
                                                            <FormLabel fontSize="sm">Parcelas</FormLabel>
                                                            <Input size="sm" type="number" value={editablePayload.payment.installments} onChange={(e) => handlePayloadChange('payment', 'installments', parseInt(e.target.value))} />
                                                        </FormControl>
                                                    </Grid>
                                                </AccordionPanel>
                                            </AccordionItem>

                                        </Accordion>
                                    </Stack>
                                ) : (
                                    /* --- MODO VISUALIZAÇÃO DE RESULTADO (Sucesso ou Erro) --- */
                                    <>
                                        {nfeTagaResult?.success ? (
                                            <Flex direction="column" align="center" textAlign="center">
                                                <FaCheckCircle size="50px" color="green" />
                                                <Text fontSize="2xl" fontWeight="bold" mt={4} color="green.600">
                                                    Nota Autorizada!
                                                </Text>
                                                <Text mt={2}>A NF-e foi emitida com sucesso.</Text>

                                                <Box mt={4} p={4} bg="gray.50" borderRadius="md" w="100%" textAlign="left">
                                                    <Text><b>Número:</b> {nfeTagaResult.nfe.numero}</Text>
                                                    <Text><b>Série:</b> {nfeTagaResult.nfe.serie}</Text>
                                                    <Text><b>Protocolo:</b> {nfeTagaResult.nfe.protocolo}</Text>
                                                    <Text><b>Chave:</b> <Text as="span" fontSize="xs">{nfeTagaResult.nfe.chave}</Text></Text>
                                                </Box>

                                                <Stack
                                                    mt={6}
                                                    spacing={4}
                                                    direction={{ base: 'column', md: 'row' }}
                                                    w="100%"
                                                    justify="center"
                                                >
                                                    <Button
                                                        leftIcon={<FaFileInvoice />}
                                                        colorScheme="blue"
                                                        onClick={() => handleDownloadArquivoNfe(nfeTagaResult.nfe.id, 'danfe')}
                                                        isLoading={downloadingNfeType === 'danfe'}
                                                        loadingText="Baixando..."
                                                        isDisabled={downloadingNfeType !== null}
                                                        w={{ base: "100%", md: "auto" }}
                                                    >
                                                        Baixar DANFE (PDF)
                                                    </Button>

                                                    <Button
                                                        leftIcon={<FaDownload />}
                                                        variant="outline"
                                                        onClick={() => handleDownloadArquivoNfe(nfeTagaResult.nfe.id, 'xml')}
                                                        isLoading={downloadingNfeType === 'xml'}
                                                        loadingText="Baixando..."
                                                        isDisabled={downloadingNfeType !== null}
                                                        w={{ base: "100%", md: "auto" }}
                                                    >
                                                        Baixar XML
                                                    </Button>
                                                </Stack>
                                            </Flex>
                                        ) : (
                                            <Flex direction="column" align="center">
                                                <MdErrorOutline size="50px" color="red" />
                                                <Text fontSize="xl" fontWeight="bold" mt={4} color="red.600">
                                                    Falha na Emissão
                                                </Text>

                                                <Box mt={4} p={4} bg="red.50" borderRadius="md" w="100%">
                                                    <Text fontWeight="bold" color="red.700">Erro:</Text>
                                                    <Text mb={2}>{nfeTagaErrorDetail?.error || "Erro desconhecido"}</Text>

                                                    <Text fontWeight="bold" color="red.700">Mensagem:</Text>
                                                    <Text mb={2}>{nfeTagaErrorDetail?.message}</Text>

                                                    {nfeTagaErrorDetail?.details && (
                                                        <Box mt={2} borderTop="1px solid" borderColor="red.200" pt={2}>
                                                            <Text fontWeight="bold" fontSize="sm">Detalhes Técnicos:</Text>
                                                            <Text fontSize="sm">Código: {nfeTagaErrorDetail.details.codigo}</Text>
                                                            <Text fontSize="sm">Motivo: {nfeTagaErrorDetail.details.motivo}</Text>

                                                            {nfeTagaErrorDetail.details.dicas && (
                                                                <Box mt={2}>
                                                                    <Text fontWeight="bold" fontSize="sm">Dicas para resolver:</Text>
                                                                    <UnorderedList fontSize="sm">
                                                                        {nfeTagaErrorDetail.details.dicas.map((dica, idx) => (
                                                                            <ListItem key={idx}>{dica}</ListItem>
                                                                        ))}
                                                                    </UnorderedList>
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Flex>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        {isEditingNfePayload ? (
                            <>
                                <Button variant="ghost" mr={3} onClick={() => setIsEditingNfePayload(false)}>
                                    Cancelar
                                </Button>
                                <Button colorScheme="orange" onClick={handleResendEditedNfe}>
                                    Reenviar
                                </Button>
                            </>
                        ) : (
                            <>
                                {!loadingNfeTaga && nfeTagaResult && !nfeTagaResult.success && (
                                    <>
                                        <Button
                                            colorScheme="blue"
                                            variant="outline"
                                            mr={3}
                                            onClick={handleSimpleRetryNfe}
                                        >
                                            Reenviar
                                        </Button>
                                        {editablePayload && (
                                            <Button
                                                colorScheme="orange"
                                                mr={3}
                                                onClick={() => setIsEditingNfePayload(true)}
                                            >
                                                Ajustar/Reenviar
                                            </Button>
                                        )}
                                    </>
                                )}

                                <Button onClick={handleCloseModalNfeTaga}>Fechar</Button>
                            </>
                        )}
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal isOpen={isModalConfirmNfeTagaOpen} onClose={closeModalConfirmNfeTaga}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Confirmação</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="16" mb={4}>
                            Tem certeza de que deseja emitir a nota fiscal da venda <b>{vendaIdParaEmitirNfe}</b>?
                        </Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleConfirmEmitirNfeTaga}>
                            Confirmar
                        </Button>
                        <Button variant="ghost" onClick={closeModalConfirmNfeTaga}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal isOpen={modalFuroItens !== null} onClose={() => setModalFuroItens(null)} size="lg" isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader fontSize="18px">Furo de estoque — quais itens?</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="13px" color="gray.600" mb={3}>
                            Marque só as peças que o fornecedor não tem. As demais seguem para
                            a expedição e continuam sendo compradas normalmente.
                        </Text>
                        <VStack align="stretch" spacing={2}>
                            {(pedidos.find(p => p.id === modalFuroItens?.pedidoId)?.produtos || [])
                                .filter(produto => produto.item_venda_id)
                                .map(produto => (
                                    <Flex
                                        key={produto.item_venda_id}
                                        align="center"
                                        p={2}
                                        borderWidth="1px"
                                        borderRadius="md"
                                        borderColor={modalFuroItens?.selecionados?.includes(produto.item_venda_id) ? 'red.300' : 'gray.200'}
                                        bg={modalFuroItens?.selecionados?.includes(produto.item_venda_id) ? 'red.50' : 'white'}
                                    >
                                        <Checkbox
                                            colorScheme="red"
                                            isChecked={modalFuroItens?.selecionados?.includes(produto.item_venda_id) || false}
                                            onChange={() => toggleItemFuro(produto.item_venda_id)}
                                            mr={3}
                                        />
                                        <Box flex="1" fontSize="12px">
                                            <Text fontWeight="bold" noOfLines={1}>{produto.nome}</Text>
                                            <Text color="gray.600">
                                                SKU {produto.id} · {produto.codigo || '-'} · {produto.fornecedor} · {produto.quantidade}x
                                            </Text>
                                        </Box>
                                        {Number(produto.furo_estoque) === 1 && (
                                            <Badge colorScheme="red" fontSize="10px">em furo</Badge>
                                        )}
                                        {Number(produto.furo_estoque_coberto) === 1 && Number(produto.furo_estoque) !== 1 && (
                                            <Badge colorScheme="green" fontSize="10px">coberto</Badge>
                                        )}
                                    </Flex>
                                ))}
                        </VStack>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="red" mr={3} onClick={confirmarFuroItens}>Salvar</Button>
                        <Button variant="ghost" onClick={() => setModalFuroItens(null)}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default Vendas;
